import { UI_AUTH_CHANNEL, TOAST_AUTH_ERROR_EVENT, AUTH_STATE_CHANGE_EVENT, AuthState, ChallengeName, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { AmplifyAuthenticator } from '@aws-amplify/ui-react';
import { prop, isEmpty, isNotNilOrEmpty, isNotNil, equals, compose, trim, join } from '@solta/ramda-extra';
import React, { useContext, memo, useState, useCallback, useEffect } from 'react';
import { Hub, I18n, Auth } from 'aws-amplify';
import { Field, Formik, Form } from 'formik';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { CognitoUser } from '@aws-amplify/auth';
import PropTypes from 'prop-types';
import * as Validator from 'yup';
import { camelizeKeys } from 'humps';
import { AuthSdk } from '@midas/idkit';
import QRCode from 'qrcode.react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// THIS FILE IS AUTOGENERATED VIA HEADWIND. DO NOT MODIFY IT DIRECTLY. MANUAL CHANGES
// WILL BE OVERWRITTEN THE NEXT TIME THIS FILE IS AUTOGENERATED.
var headwindUtilities = Object.freeze({
  "content-start": {
    "alignContent": "flex-start"
  },
  "content-end": {
    "alignContent": "flex-end"
  },
  "content-center": {
    "alignContent": "center"
  },
  "content-between": {
    "alignContent": "space-between"
  },
  "content-around": {
    "alignContent": "space-around"
  },
  "items-stretch": {
    "alignItems": "stretch"
  },
  "items-start": {
    "alignItems": "flex-start"
  },
  "items-end": {
    "alignItems": "flex-end"
  },
  "items-center": {
    "alignItems": "center"
  },
  "items-baseline": {
    "alignItems": "baseline"
  },
  "self-auto": {
    "alignSelf": "auto"
  },
  "self-start": {
    "alignSelf": "flex-start"
  },
  "self-end": {
    "alignSelf": "flex-end"
  },
  "self-center": {
    "alignSelf": "center"
  },
  "self-stretch": {
    "alignSelf": "stretch"
  },
  "self-baseline": {
    "alignSelf": "baseline"
  },
  "bg-transparent": {
    "backgroundColor": "transparent"
  },
  "bg-white": {
    "backgroundColor": "white"
  },
  "bg-black": {
    "backgroundColor": "black"
  },
  "bg-gray-50": {
    "backgroundColor": "#FAFAFA"
  },
  "bg-gray-100": {
    "backgroundColor": "#F4F4F5"
  },
  "bg-gray-200": {
    "backgroundColor": "#E4E4E7"
  },
  "bg-gray-300": {
    "backgroundColor": "#D4D4D8"
  },
  "bg-gray-400": {
    "backgroundColor": "#A1A1AA"
  },
  "bg-gray-500": {
    "backgroundColor": "#71717A"
  },
  "bg-gray-600": {
    "backgroundColor": "#52525B"
  },
  "bg-gray-700": {
    "backgroundColor": "#3F3F46"
  },
  "bg-gray-800": {
    "backgroundColor": "#27272A"
  },
  "bg-gray-900": {
    "backgroundColor": "#18181B"
  },
  "bg-rose-50": {
    "backgroundColor": "#fff1f2"
  },
  "bg-rose-100": {
    "backgroundColor": "#ffe4e6"
  },
  "bg-rose-200": {
    "backgroundColor": "#fecdd3"
  },
  "bg-rose-300": {
    "backgroundColor": "#fda4af"
  },
  "bg-rose-400": {
    "backgroundColor": "#fb7185"
  },
  "bg-rose-500": {
    "backgroundColor": "#f43f5e"
  },
  "bg-rose-600": {
    "backgroundColor": "#e11d48"
  },
  "bg-rose-700": {
    "backgroundColor": "#be123c"
  },
  "bg-rose-800": {
    "backgroundColor": "#9f1239"
  },
  "bg-rose-900": {
    "backgroundColor": "#881337"
  },
  "bg-pink-50": {
    "backgroundColor": "#fdf2f8"
  },
  "bg-pink-100": {
    "backgroundColor": "#fce7f3"
  },
  "bg-pink-200": {
    "backgroundColor": "#fbcfe8"
  },
  "bg-pink-300": {
    "backgroundColor": "#f9a8d4"
  },
  "bg-pink-400": {
    "backgroundColor": "#f472b6"
  },
  "bg-pink-500": {
    "backgroundColor": "#ec4899"
  },
  "bg-pink-600": {
    "backgroundColor": "#db2777"
  },
  "bg-pink-700": {
    "backgroundColor": "#be185d"
  },
  "bg-pink-800": {
    "backgroundColor": "#9d174d"
  },
  "bg-pink-900": {
    "backgroundColor": "#831843"
  },
  "bg-fuchsia-50": {
    "backgroundColor": "#fdf4ff"
  },
  "bg-fuchsia-100": {
    "backgroundColor": "#fae8ff"
  },
  "bg-fuchsia-200": {
    "backgroundColor": "#f5d0fe"
  },
  "bg-fuchsia-300": {
    "backgroundColor": "#f0abfc"
  },
  "bg-fuchsia-400": {
    "backgroundColor": "#e879f9"
  },
  "bg-fuchsia-500": {
    "backgroundColor": "#d946ef"
  },
  "bg-fuchsia-600": {
    "backgroundColor": "#c026d3"
  },
  "bg-fuchsia-700": {
    "backgroundColor": "#a21caf"
  },
  "bg-fuchsia-800": {
    "backgroundColor": "#86198f"
  },
  "bg-fuchsia-900": {
    "backgroundColor": "#701a75"
  },
  "bg-purple-50": {
    "backgroundColor": "#faf5ff"
  },
  "bg-purple-100": {
    "backgroundColor": "#f3e8ff"
  },
  "bg-purple-200": {
    "backgroundColor": "#e9d5ff"
  },
  "bg-purple-300": {
    "backgroundColor": "#d8b4fe"
  },
  "bg-purple-400": {
    "backgroundColor": "#c084fc"
  },
  "bg-purple-500": {
    "backgroundColor": "#a855f7"
  },
  "bg-purple-600": {
    "backgroundColor": "#9333ea"
  },
  "bg-purple-700": {
    "backgroundColor": "#7e22ce"
  },
  "bg-purple-800": {
    "backgroundColor": "#6b21a8"
  },
  "bg-purple-900": {
    "backgroundColor": "#581c87"
  },
  "bg-violet-50": {
    "backgroundColor": "#f5f3ff"
  },
  "bg-violet-100": {
    "backgroundColor": "#ede9fe"
  },
  "bg-violet-200": {
    "backgroundColor": "#ddd6fe"
  },
  "bg-violet-300": {
    "backgroundColor": "#c4b5fd"
  },
  "bg-violet-400": {
    "backgroundColor": "#a78bfa"
  },
  "bg-violet-500": {
    "backgroundColor": "#8b5cf6"
  },
  "bg-violet-600": {
    "backgroundColor": "#7c3aed"
  },
  "bg-violet-700": {
    "backgroundColor": "#6d28d9"
  },
  "bg-violet-800": {
    "backgroundColor": "#5b21b6"
  },
  "bg-violet-900": {
    "backgroundColor": "#4c1d95"
  },
  "bg-indigo-50": {
    "backgroundColor": "#eef2ff"
  },
  "bg-indigo-100": {
    "backgroundColor": "#e0e7ff"
  },
  "bg-indigo-200": {
    "backgroundColor": "#c7d2fe"
  },
  "bg-indigo-300": {
    "backgroundColor": "#a5b4fc"
  },
  "bg-indigo-400": {
    "backgroundColor": "#818cf8"
  },
  "bg-indigo-500": {
    "backgroundColor": "#6366f1"
  },
  "bg-indigo-600": {
    "backgroundColor": "#4f46e5"
  },
  "bg-indigo-700": {
    "backgroundColor": "#4338ca"
  },
  "bg-indigo-800": {
    "backgroundColor": "#3730a3"
  },
  "bg-indigo-900": {
    "backgroundColor": "#312e81"
  },
  "bg-blue-50": {
    "backgroundColor": "#eff6ff"
  },
  "bg-blue-100": {
    "backgroundColor": "#dbeafe"
  },
  "bg-blue-200": {
    "backgroundColor": "#bfdbfe"
  },
  "bg-blue-300": {
    "backgroundColor": "#93c5fd"
  },
  "bg-blue-400": {
    "backgroundColor": "#60a5fa"
  },
  "bg-blue-500": {
    "backgroundColor": "#3b82f6"
  },
  "bg-blue-600": {
    "backgroundColor": "#2563eb"
  },
  "bg-blue-700": {
    "backgroundColor": "#1d4ed8"
  },
  "bg-blue-800": {
    "backgroundColor": "#1e40af"
  },
  "bg-blue-900": {
    "backgroundColor": "#1e3a8a"
  },
  "bg-lightBlue-50": {
    "backgroundColor": "#f0f9ff"
  },
  "bg-lightBlue-100": {
    "backgroundColor": "#e0f2fe"
  },
  "bg-lightBlue-200": {
    "backgroundColor": "#bae6fd"
  },
  "bg-lightBlue-300": {
    "backgroundColor": "#7dd3fc"
  },
  "bg-lightBlue-400": {
    "backgroundColor": "#38bdf8"
  },
  "bg-lightBlue-500": {
    "backgroundColor": "#0ea5e9"
  },
  "bg-lightBlue-600": {
    "backgroundColor": "#0284c7"
  },
  "bg-lightBlue-700": {
    "backgroundColor": "#0369a1"
  },
  "bg-lightBlue-800": {
    "backgroundColor": "#075985"
  },
  "bg-lightBlue-900": {
    "backgroundColor": "#0c4a6e"
  },
  "bg-cyan-50": {
    "backgroundColor": "#ecfeff"
  },
  "bg-cyan-100": {
    "backgroundColor": "#cffafe"
  },
  "bg-cyan-200": {
    "backgroundColor": "#a5f3fc"
  },
  "bg-cyan-300": {
    "backgroundColor": "#67e8f9"
  },
  "bg-cyan-400": {
    "backgroundColor": "#22d3ee"
  },
  "bg-cyan-500": {
    "backgroundColor": "#06b6d4"
  },
  "bg-cyan-600": {
    "backgroundColor": "#0891b2"
  },
  "bg-cyan-700": {
    "backgroundColor": "#0e7490"
  },
  "bg-cyan-800": {
    "backgroundColor": "#155e75"
  },
  "bg-cyan-900": {
    "backgroundColor": "#164e63"
  },
  "bg-teal-50": {
    "backgroundColor": "#f0fdfa"
  },
  "bg-teal-100": {
    "backgroundColor": "#ccfbf1"
  },
  "bg-teal-200": {
    "backgroundColor": "#99f6e4"
  },
  "bg-teal-300": {
    "backgroundColor": "#5eead4"
  },
  "bg-teal-400": {
    "backgroundColor": "#2dd4bf"
  },
  "bg-teal-500": {
    "backgroundColor": "#14b8a6"
  },
  "bg-teal-600": {
    "backgroundColor": "#0d9488"
  },
  "bg-teal-700": {
    "backgroundColor": "#0f766e"
  },
  "bg-teal-800": {
    "backgroundColor": "#115e59"
  },
  "bg-teal-900": {
    "backgroundColor": "#134e4a"
  },
  "bg-emerald-50": {
    "backgroundColor": "#ecfdf5"
  },
  "bg-emerald-100": {
    "backgroundColor": "#d1fae5"
  },
  "bg-emerald-200": {
    "backgroundColor": "#a7f3d0"
  },
  "bg-emerald-300": {
    "backgroundColor": "#6ee7b7"
  },
  "bg-emerald-400": {
    "backgroundColor": "#34d399"
  },
  "bg-emerald-500": {
    "backgroundColor": "#10b981"
  },
  "bg-emerald-600": {
    "backgroundColor": "#059669"
  },
  "bg-emerald-700": {
    "backgroundColor": "#047857"
  },
  "bg-emerald-800": {
    "backgroundColor": "#065f46"
  },
  "bg-emerald-900": {
    "backgroundColor": "#064e3b"
  },
  "bg-green-50": {
    "backgroundColor": "#f0fdf4"
  },
  "bg-green-100": {
    "backgroundColor": "#dcfce7"
  },
  "bg-green-200": {
    "backgroundColor": "#bbf7d0"
  },
  "bg-green-300": {
    "backgroundColor": "#86efac"
  },
  "bg-green-400": {
    "backgroundColor": "#4ade80"
  },
  "bg-green-500": {
    "backgroundColor": "#22c55e"
  },
  "bg-green-600": {
    "backgroundColor": "#16a34a"
  },
  "bg-green-700": {
    "backgroundColor": "#15803d"
  },
  "bg-green-800": {
    "backgroundColor": "#166534"
  },
  "bg-green-900": {
    "backgroundColor": "#14532d"
  },
  "bg-lime-50": {
    "backgroundColor": "#f7fee7"
  },
  "bg-lime-100": {
    "backgroundColor": "#ecfccb"
  },
  "bg-lime-200": {
    "backgroundColor": "#d9f99d"
  },
  "bg-lime-300": {
    "backgroundColor": "#bef264"
  },
  "bg-lime-400": {
    "backgroundColor": "#a3e635"
  },
  "bg-lime-500": {
    "backgroundColor": "#84cc16"
  },
  "bg-lime-600": {
    "backgroundColor": "#65a30d"
  },
  "bg-lime-700": {
    "backgroundColor": "#4d7c0f"
  },
  "bg-lime-800": {
    "backgroundColor": "#3f6212"
  },
  "bg-lime-900": {
    "backgroundColor": "#365314"
  },
  "bg-yellow-50": {
    "backgroundColor": "#fefce8"
  },
  "bg-yellow-100": {
    "backgroundColor": "#fef9c3"
  },
  "bg-yellow-200": {
    "backgroundColor": "#fef08a"
  },
  "bg-yellow-300": {
    "backgroundColor": "#fde047"
  },
  "bg-yellow-400": {
    "backgroundColor": "#facc15"
  },
  "bg-yellow-500": {
    "backgroundColor": "#eab308"
  },
  "bg-yellow-600": {
    "backgroundColor": "#ca8a04"
  },
  "bg-yellow-700": {
    "backgroundColor": "#a16207"
  },
  "bg-yellow-800": {
    "backgroundColor": "#854d0e"
  },
  "bg-yellow-900": {
    "backgroundColor": "#713f12"
  },
  "bg-amber-50": {
    "backgroundColor": "#fffbeb"
  },
  "bg-amber-100": {
    "backgroundColor": "#fef3c7"
  },
  "bg-amber-200": {
    "backgroundColor": "#fde68a"
  },
  "bg-amber-300": {
    "backgroundColor": "#fcd34d"
  },
  "bg-amber-400": {
    "backgroundColor": "#fbbf24"
  },
  "bg-amber-500": {
    "backgroundColor": "#f59e0b"
  },
  "bg-amber-600": {
    "backgroundColor": "#d97706"
  },
  "bg-amber-700": {
    "backgroundColor": "#b45309"
  },
  "bg-amber-800": {
    "backgroundColor": "#92400e"
  },
  "bg-amber-900": {
    "backgroundColor": "#78350f"
  },
  "bg-orange-50": {
    "backgroundColor": "#fff7ed"
  },
  "bg-orange-100": {
    "backgroundColor": "#ffedd5"
  },
  "bg-orange-200": {
    "backgroundColor": "#fed7aa"
  },
  "bg-orange-300": {
    "backgroundColor": "#fdba74"
  },
  "bg-orange-400": {
    "backgroundColor": "#fb923c"
  },
  "bg-orange-500": {
    "backgroundColor": "#f97316"
  },
  "bg-orange-600": {
    "backgroundColor": "#ea580c"
  },
  "bg-orange-700": {
    "backgroundColor": "#c2410c"
  },
  "bg-orange-800": {
    "backgroundColor": "#9a3412"
  },
  "bg-orange-900": {
    "backgroundColor": "#7c2d12"
  },
  "bg-red-50": {
    "backgroundColor": "#fef2f2"
  },
  "bg-red-100": {
    "backgroundColor": "#fee2e2"
  },
  "bg-red-200": {
    "backgroundColor": "#fecaca"
  },
  "bg-red-300": {
    "backgroundColor": "#fca5a5"
  },
  "bg-red-400": {
    "backgroundColor": "#f87171"
  },
  "bg-red-500": {
    "backgroundColor": "#ef4444"
  },
  "bg-red-600": {
    "backgroundColor": "#dc2626"
  },
  "bg-red-700": {
    "backgroundColor": "#b91c1c"
  },
  "bg-red-800": {
    "backgroundColor": "#991b1b"
  },
  "bg-red-900": {
    "backgroundColor": "#7f1d1d"
  },
  "bg-grey-50": {
    "backgroundColor": "#FBFBFB"
  },
  "bg-grey-100": {
    "backgroundColor": "#F2F3F2"
  },
  "bg-grey-200": {
    "backgroundColor": "#E4E6E6"
  },
  "bg-grey-300": {
    "backgroundColor": "#D7DAD9"
  },
  "bg-grey-400": {
    "backgroundColor": "C9CECD"
  },
  "bg-grey-500": {
    "backgroundColor": "#A5ADAB"
  },
  "bg-grey-600": {
    "backgroundColor": "#798582"
  },
  "bg-grey-700": {
    "backgroundColor": "#515856"
  },
  "bg-grey-800": {
    "backgroundColor": "#282C2B"
  },
  "bg-grey-900": {
    "backgroundColor": "#141616"
  },
  "bg-error": {
    "backgroundColor": "#F35A56"
  },
  "border-transparent": {
    "borderColor": "transparent"
  },
  "border-white": {
    "borderColor": "white"
  },
  "border-black": {
    "borderColor": "black"
  },
  "border-gray-50": {
    "borderColor": "#FAFAFA"
  },
  "border-gray-100": {
    "borderColor": "#F4F4F5"
  },
  "border-gray-200": {
    "borderColor": "#E4E4E7"
  },
  "border-gray-300": {
    "borderColor": "#D4D4D8"
  },
  "border-gray-400": {
    "borderColor": "#A1A1AA"
  },
  "border-gray-500": {
    "borderColor": "#71717A"
  },
  "border-gray-600": {
    "borderColor": "#52525B"
  },
  "border-gray-700": {
    "borderColor": "#3F3F46"
  },
  "border-gray-800": {
    "borderColor": "#27272A"
  },
  "border-gray-900": {
    "borderColor": "#18181B"
  },
  "border-rose-50": {
    "borderColor": "#fff1f2"
  },
  "border-rose-100": {
    "borderColor": "#ffe4e6"
  },
  "border-rose-200": {
    "borderColor": "#fecdd3"
  },
  "border-rose-300": {
    "borderColor": "#fda4af"
  },
  "border-rose-400": {
    "borderColor": "#fb7185"
  },
  "border-rose-500": {
    "borderColor": "#f43f5e"
  },
  "border-rose-600": {
    "borderColor": "#e11d48"
  },
  "border-rose-700": {
    "borderColor": "#be123c"
  },
  "border-rose-800": {
    "borderColor": "#9f1239"
  },
  "border-rose-900": {
    "borderColor": "#881337"
  },
  "border-pink-50": {
    "borderColor": "#fdf2f8"
  },
  "border-pink-100": {
    "borderColor": "#fce7f3"
  },
  "border-pink-200": {
    "borderColor": "#fbcfe8"
  },
  "border-pink-300": {
    "borderColor": "#f9a8d4"
  },
  "border-pink-400": {
    "borderColor": "#f472b6"
  },
  "border-pink-500": {
    "borderColor": "#ec4899"
  },
  "border-pink-600": {
    "borderColor": "#db2777"
  },
  "border-pink-700": {
    "borderColor": "#be185d"
  },
  "border-pink-800": {
    "borderColor": "#9d174d"
  },
  "border-pink-900": {
    "borderColor": "#831843"
  },
  "border-fuchsia-50": {
    "borderColor": "#fdf4ff"
  },
  "border-fuchsia-100": {
    "borderColor": "#fae8ff"
  },
  "border-fuchsia-200": {
    "borderColor": "#f5d0fe"
  },
  "border-fuchsia-300": {
    "borderColor": "#f0abfc"
  },
  "border-fuchsia-400": {
    "borderColor": "#e879f9"
  },
  "border-fuchsia-500": {
    "borderColor": "#d946ef"
  },
  "border-fuchsia-600": {
    "borderColor": "#c026d3"
  },
  "border-fuchsia-700": {
    "borderColor": "#a21caf"
  },
  "border-fuchsia-800": {
    "borderColor": "#86198f"
  },
  "border-fuchsia-900": {
    "borderColor": "#701a75"
  },
  "border-purple-50": {
    "borderColor": "#faf5ff"
  },
  "border-purple-100": {
    "borderColor": "#f3e8ff"
  },
  "border-purple-200": {
    "borderColor": "#e9d5ff"
  },
  "border-purple-300": {
    "borderColor": "#d8b4fe"
  },
  "border-purple-400": {
    "borderColor": "#c084fc"
  },
  "border-purple-500": {
    "borderColor": "#a855f7"
  },
  "border-purple-600": {
    "borderColor": "#9333ea"
  },
  "border-purple-700": {
    "borderColor": "#7e22ce"
  },
  "border-purple-800": {
    "borderColor": "#6b21a8"
  },
  "border-purple-900": {
    "borderColor": "#581c87"
  },
  "border-violet-50": {
    "borderColor": "#f5f3ff"
  },
  "border-violet-100": {
    "borderColor": "#ede9fe"
  },
  "border-violet-200": {
    "borderColor": "#ddd6fe"
  },
  "border-violet-300": {
    "borderColor": "#c4b5fd"
  },
  "border-violet-400": {
    "borderColor": "#a78bfa"
  },
  "border-violet-500": {
    "borderColor": "#8b5cf6"
  },
  "border-violet-600": {
    "borderColor": "#7c3aed"
  },
  "border-violet-700": {
    "borderColor": "#6d28d9"
  },
  "border-violet-800": {
    "borderColor": "#5b21b6"
  },
  "border-violet-900": {
    "borderColor": "#4c1d95"
  },
  "border-indigo-50": {
    "borderColor": "#eef2ff"
  },
  "border-indigo-100": {
    "borderColor": "#e0e7ff"
  },
  "border-indigo-200": {
    "borderColor": "#c7d2fe"
  },
  "border-indigo-300": {
    "borderColor": "#a5b4fc"
  },
  "border-indigo-400": {
    "borderColor": "#818cf8"
  },
  "border-indigo-500": {
    "borderColor": "#6366f1"
  },
  "border-indigo-600": {
    "borderColor": "#4f46e5"
  },
  "border-indigo-700": {
    "borderColor": "#4338ca"
  },
  "border-indigo-800": {
    "borderColor": "#3730a3"
  },
  "border-indigo-900": {
    "borderColor": "#312e81"
  },
  "border-blue-50": {
    "borderColor": "#eff6ff"
  },
  "border-blue-100": {
    "borderColor": "#dbeafe"
  },
  "border-blue-200": {
    "borderColor": "#bfdbfe"
  },
  "border-blue-300": {
    "borderColor": "#93c5fd"
  },
  "border-blue-400": {
    "borderColor": "#60a5fa"
  },
  "border-blue-500": {
    "borderColor": "#3b82f6"
  },
  "border-blue-600": {
    "borderColor": "#2563eb"
  },
  "border-blue-700": {
    "borderColor": "#1d4ed8"
  },
  "border-blue-800": {
    "borderColor": "#1e40af"
  },
  "border-blue-900": {
    "borderColor": "#1e3a8a"
  },
  "border-lightBlue-50": {
    "borderColor": "#f0f9ff"
  },
  "border-lightBlue-100": {
    "borderColor": "#e0f2fe"
  },
  "border-lightBlue-200": {
    "borderColor": "#bae6fd"
  },
  "border-lightBlue-300": {
    "borderColor": "#7dd3fc"
  },
  "border-lightBlue-400": {
    "borderColor": "#38bdf8"
  },
  "border-lightBlue-500": {
    "borderColor": "#0ea5e9"
  },
  "border-lightBlue-600": {
    "borderColor": "#0284c7"
  },
  "border-lightBlue-700": {
    "borderColor": "#0369a1"
  },
  "border-lightBlue-800": {
    "borderColor": "#075985"
  },
  "border-lightBlue-900": {
    "borderColor": "#0c4a6e"
  },
  "border-cyan-50": {
    "borderColor": "#ecfeff"
  },
  "border-cyan-100": {
    "borderColor": "#cffafe"
  },
  "border-cyan-200": {
    "borderColor": "#a5f3fc"
  },
  "border-cyan-300": {
    "borderColor": "#67e8f9"
  },
  "border-cyan-400": {
    "borderColor": "#22d3ee"
  },
  "border-cyan-500": {
    "borderColor": "#06b6d4"
  },
  "border-cyan-600": {
    "borderColor": "#0891b2"
  },
  "border-cyan-700": {
    "borderColor": "#0e7490"
  },
  "border-cyan-800": {
    "borderColor": "#155e75"
  },
  "border-cyan-900": {
    "borderColor": "#164e63"
  },
  "border-teal-50": {
    "borderColor": "#f0fdfa"
  },
  "border-teal-100": {
    "borderColor": "#ccfbf1"
  },
  "border-teal-200": {
    "borderColor": "#99f6e4"
  },
  "border-teal-300": {
    "borderColor": "#5eead4"
  },
  "border-teal-400": {
    "borderColor": "#2dd4bf"
  },
  "border-teal-500": {
    "borderColor": "#14b8a6"
  },
  "border-teal-600": {
    "borderColor": "#0d9488"
  },
  "border-teal-700": {
    "borderColor": "#0f766e"
  },
  "border-teal-800": {
    "borderColor": "#115e59"
  },
  "border-teal-900": {
    "borderColor": "#134e4a"
  },
  "border-emerald-50": {
    "borderColor": "#ecfdf5"
  },
  "border-emerald-100": {
    "borderColor": "#d1fae5"
  },
  "border-emerald-200": {
    "borderColor": "#a7f3d0"
  },
  "border-emerald-300": {
    "borderColor": "#6ee7b7"
  },
  "border-emerald-400": {
    "borderColor": "#34d399"
  },
  "border-emerald-500": {
    "borderColor": "#10b981"
  },
  "border-emerald-600": {
    "borderColor": "#059669"
  },
  "border-emerald-700": {
    "borderColor": "#047857"
  },
  "border-emerald-800": {
    "borderColor": "#065f46"
  },
  "border-emerald-900": {
    "borderColor": "#064e3b"
  },
  "border-green-50": {
    "borderColor": "#f0fdf4"
  },
  "border-green-100": {
    "borderColor": "#dcfce7"
  },
  "border-green-200": {
    "borderColor": "#bbf7d0"
  },
  "border-green-300": {
    "borderColor": "#86efac"
  },
  "border-green-400": {
    "borderColor": "#4ade80"
  },
  "border-green-500": {
    "borderColor": "#22c55e"
  },
  "border-green-600": {
    "borderColor": "#16a34a"
  },
  "border-green-700": {
    "borderColor": "#15803d"
  },
  "border-green-800": {
    "borderColor": "#166534"
  },
  "border-green-900": {
    "borderColor": "#14532d"
  },
  "border-lime-50": {
    "borderColor": "#f7fee7"
  },
  "border-lime-100": {
    "borderColor": "#ecfccb"
  },
  "border-lime-200": {
    "borderColor": "#d9f99d"
  },
  "border-lime-300": {
    "borderColor": "#bef264"
  },
  "border-lime-400": {
    "borderColor": "#a3e635"
  },
  "border-lime-500": {
    "borderColor": "#84cc16"
  },
  "border-lime-600": {
    "borderColor": "#65a30d"
  },
  "border-lime-700": {
    "borderColor": "#4d7c0f"
  },
  "border-lime-800": {
    "borderColor": "#3f6212"
  },
  "border-lime-900": {
    "borderColor": "#365314"
  },
  "border-yellow-50": {
    "borderColor": "#fefce8"
  },
  "border-yellow-100": {
    "borderColor": "#fef9c3"
  },
  "border-yellow-200": {
    "borderColor": "#fef08a"
  },
  "border-yellow-300": {
    "borderColor": "#fde047"
  },
  "border-yellow-400": {
    "borderColor": "#facc15"
  },
  "border-yellow-500": {
    "borderColor": "#eab308"
  },
  "border-yellow-600": {
    "borderColor": "#ca8a04"
  },
  "border-yellow-700": {
    "borderColor": "#a16207"
  },
  "border-yellow-800": {
    "borderColor": "#854d0e"
  },
  "border-yellow-900": {
    "borderColor": "#713f12"
  },
  "border-amber-50": {
    "borderColor": "#fffbeb"
  },
  "border-amber-100": {
    "borderColor": "#fef3c7"
  },
  "border-amber-200": {
    "borderColor": "#fde68a"
  },
  "border-amber-300": {
    "borderColor": "#fcd34d"
  },
  "border-amber-400": {
    "borderColor": "#fbbf24"
  },
  "border-amber-500": {
    "borderColor": "#f59e0b"
  },
  "border-amber-600": {
    "borderColor": "#d97706"
  },
  "border-amber-700": {
    "borderColor": "#b45309"
  },
  "border-amber-800": {
    "borderColor": "#92400e"
  },
  "border-amber-900": {
    "borderColor": "#78350f"
  },
  "border-orange-50": {
    "borderColor": "#fff7ed"
  },
  "border-orange-100": {
    "borderColor": "#ffedd5"
  },
  "border-orange-200": {
    "borderColor": "#fed7aa"
  },
  "border-orange-300": {
    "borderColor": "#fdba74"
  },
  "border-orange-400": {
    "borderColor": "#fb923c"
  },
  "border-orange-500": {
    "borderColor": "#f97316"
  },
  "border-orange-600": {
    "borderColor": "#ea580c"
  },
  "border-orange-700": {
    "borderColor": "#c2410c"
  },
  "border-orange-800": {
    "borderColor": "#9a3412"
  },
  "border-orange-900": {
    "borderColor": "#7c2d12"
  },
  "border-red-50": {
    "borderColor": "#fef2f2"
  },
  "border-red-100": {
    "borderColor": "#fee2e2"
  },
  "border-red-200": {
    "borderColor": "#fecaca"
  },
  "border-red-300": {
    "borderColor": "#fca5a5"
  },
  "border-red-400": {
    "borderColor": "#f87171"
  },
  "border-red-500": {
    "borderColor": "#ef4444"
  },
  "border-red-600": {
    "borderColor": "#dc2626"
  },
  "border-red-700": {
    "borderColor": "#b91c1c"
  },
  "border-red-800": {
    "borderColor": "#991b1b"
  },
  "border-red-900": {
    "borderColor": "#7f1d1d"
  },
  "border-grey-50": {
    "borderColor": "#FBFBFB"
  },
  "border-grey-100": {
    "borderColor": "#F2F3F2"
  },
  "border-grey-200": {
    "borderColor": "#E4E6E6"
  },
  "border-grey-300": {
    "borderColor": "#D7DAD9"
  },
  "border-grey-400": {
    "borderColor": "C9CECD"
  },
  "border-grey-500": {
    "borderColor": "#A5ADAB"
  },
  "border-grey-600": {
    "borderColor": "#798582"
  },
  "border-grey-700": {
    "borderColor": "#515856"
  },
  "border-grey-800": {
    "borderColor": "#282C2B"
  },
  "border-grey-900": {
    "borderColor": "#141616"
  },
  "border-error": {
    "borderColor": "#F35A56"
  },
  "rounded-none": {
    "borderRadius": 0
  },
  "rounded-t-none": {
    "borderTopLeftRadius": 0,
    "borderTopRightRadius": 0
  },
  "rounded-b-none": {
    "borderBottomLeftRadius": 0,
    "borderBottomRightRadius": 0
  },
  "rounded-l-none": {
    "borderTopLeftRadius": 0,
    "borderBottomLeftRadius": 0
  },
  "rounded-r-none": {
    "borderTopRightRadius": 0,
    "borderBottomRightRadius": 0
  },
  "rounded-tl-none": {
    "borderTopLeftRadius": 0
  },
  "rounded-tr-none": {
    "borderTopRightRadius": 0
  },
  "rounded-bl-none": {
    "borderBottomLeftRadius": 0
  },
  "rounded-br-none": {
    "borderBottomRightRadius": 0
  },
  "rounded-sm": {
    "borderRadius": 2
  },
  "rounded-t-sm": {
    "borderTopLeftRadius": 2,
    "borderTopRightRadius": 2
  },
  "rounded-b-sm": {
    "borderBottomLeftRadius": 2,
    "borderBottomRightRadius": 2
  },
  "rounded-l-sm": {
    "borderTopLeftRadius": 2,
    "borderBottomLeftRadius": 2
  },
  "rounded-r-sm": {
    "borderTopRightRadius": 2,
    "borderBottomRightRadius": 2
  },
  "rounded-tl-sm": {
    "borderTopLeftRadius": 2
  },
  "rounded-tr-sm": {
    "borderTopRightRadius": 2
  },
  "rounded-bl-sm": {
    "borderBottomLeftRadius": 2
  },
  "rounded-br-sm": {
    "borderBottomRightRadius": 2
  },
  "rounded-md": {
    "borderRadius": 4
  },
  "rounded-t-md": {
    "borderTopLeftRadius": 4,
    "borderTopRightRadius": 4
  },
  "rounded-b-md": {
    "borderBottomLeftRadius": 4,
    "borderBottomRightRadius": 4
  },
  "rounded-l-md": {
    "borderTopLeftRadius": 4,
    "borderBottomLeftRadius": 4
  },
  "rounded-r-md": {
    "borderTopRightRadius": 4,
    "borderBottomRightRadius": 4
  },
  "rounded-tl-md": {
    "borderTopLeftRadius": 4
  },
  "rounded-tr-md": {
    "borderTopRightRadius": 4
  },
  "rounded-bl-md": {
    "borderBottomLeftRadius": 4
  },
  "rounded-br-md": {
    "borderBottomRightRadius": 4
  },
  "rounded-lg": {
    "borderRadius": 8
  },
  "rounded-t-lg": {
    "borderTopLeftRadius": 8,
    "borderTopRightRadius": 8
  },
  "rounded-b-lg": {
    "borderBottomLeftRadius": 8,
    "borderBottomRightRadius": 8
  },
  "rounded-l-lg": {
    "borderTopLeftRadius": 8,
    "borderBottomLeftRadius": 8
  },
  "rounded-r-lg": {
    "borderTopRightRadius": 8,
    "borderBottomRightRadius": 8
  },
  "rounded-tl-lg": {
    "borderTopLeftRadius": 8
  },
  "rounded-tr-lg": {
    "borderTopRightRadius": 8
  },
  "rounded-bl-lg": {
    "borderBottomLeftRadius": 8
  },
  "rounded-br-lg": {
    "borderBottomRightRadius": 8
  },
  "rounded-xl": {
    "borderRadius": 16
  },
  "rounded-t-xl": {
    "borderTopLeftRadius": 16,
    "borderTopRightRadius": 16
  },
  "rounded-b-xl": {
    "borderBottomLeftRadius": 16,
    "borderBottomRightRadius": 16
  },
  "rounded-l-xl": {
    "borderTopLeftRadius": 16,
    "borderBottomLeftRadius": 16
  },
  "rounded-r-xl": {
    "borderTopRightRadius": 16,
    "borderBottomRightRadius": 16
  },
  "rounded-tl-xl": {
    "borderTopLeftRadius": 16
  },
  "rounded-tr-xl": {
    "borderTopRightRadius": 16
  },
  "rounded-bl-xl": {
    "borderBottomLeftRadius": 16
  },
  "rounded-br-xl": {
    "borderBottomRightRadius": 16
  },
  "rounded-2xl": {
    "borderRadius": 24
  },
  "rounded-t-2xl": {
    "borderTopLeftRadius": 24,
    "borderTopRightRadius": 24
  },
  "rounded-b-2xl": {
    "borderBottomLeftRadius": 24,
    "borderBottomRightRadius": 24
  },
  "rounded-l-2xl": {
    "borderTopLeftRadius": 24,
    "borderBottomLeftRadius": 24
  },
  "rounded-r-2xl": {
    "borderTopRightRadius": 24,
    "borderBottomRightRadius": 24
  },
  "rounded-tl-2xl": {
    "borderTopLeftRadius": 24
  },
  "rounded-tr-2xl": {
    "borderTopRightRadius": 24
  },
  "rounded-bl-2xl": {
    "borderBottomLeftRadius": 24
  },
  "rounded-br-2xl": {
    "borderBottomRightRadius": 24
  },
  "rounded-3xl": {
    "borderRadius": 32
  },
  "rounded-t-3xl": {
    "borderTopLeftRadius": 32,
    "borderTopRightRadius": 32
  },
  "rounded-b-3xl": {
    "borderBottomLeftRadius": 32,
    "borderBottomRightRadius": 32
  },
  "rounded-l-3xl": {
    "borderTopLeftRadius": 32,
    "borderBottomLeftRadius": 32
  },
  "rounded-r-3xl": {
    "borderTopRightRadius": 32,
    "borderBottomRightRadius": 32
  },
  "rounded-tl-3xl": {
    "borderTopLeftRadius": 32
  },
  "rounded-tr-3xl": {
    "borderTopRightRadius": 32
  },
  "rounded-bl-3xl": {
    "borderBottomLeftRadius": 32
  },
  "rounded-br-3xl": {
    "borderBottomRightRadius": 32
  },
  "rounded-full": {
    "borderRadius": 300
  },
  "rounded-t-full": {
    "borderTopLeftRadius": 300,
    "borderTopRightRadius": 300
  },
  "rounded-b-full": {
    "borderBottomLeftRadius": 300,
    "borderBottomRightRadius": 300
  },
  "rounded-l-full": {
    "borderTopLeftRadius": 300,
    "borderBottomLeftRadius": 300
  },
  "rounded-r-full": {
    "borderTopRightRadius": 300,
    "borderBottomRightRadius": 300
  },
  "rounded-tl-full": {
    "borderTopLeftRadius": 300
  },
  "rounded-tr-full": {
    "borderTopRightRadius": 300
  },
  "rounded-bl-full": {
    "borderBottomLeftRadius": 300
  },
  "rounded-br-full": {
    "borderBottomRightRadius": 300
  },
  "border-solid": {
    "borderStyle": "solid"
  },
  "border-dashed": {
    "borderStyle": "dashed"
  },
  "border-dotted": {
    "borderStyle": "dotted"
  },
  "border-0": {
    "borderWidth": 0
  },
  "border-t-0": {
    "borderTopWidth": 0
  },
  "border-b-0": {
    "borderBottomWidth": 0
  },
  "border-l-0": {
    "borderLeftWidth": 0
  },
  "border-r-0": {
    "borderRightWidth": 0
  },
  "border-x-0": {
    "borderLeftWidth": 0,
    "borderRightWidth": 0
  },
  "border-y-0": {
    "borderTopWidth": 0,
    "borderBottomWidth": 0
  },
  "border-1": {
    "borderWidth": 1
  },
  "border-t-1": {
    "borderTopWidth": 1
  },
  "border-b-1": {
    "borderBottomWidth": 1
  },
  "border-l-1": {
    "borderLeftWidth": 1
  },
  "border-r-1": {
    "borderRightWidth": 1
  },
  "border-x-1": {
    "borderLeftWidth": 1,
    "borderRightWidth": 1
  },
  "border-y-1": {
    "borderTopWidth": 1,
    "borderBottomWidth": 1
  },
  "border-2": {
    "borderWidth": 2
  },
  "border-t-2": {
    "borderTopWidth": 2
  },
  "border-b-2": {
    "borderBottomWidth": 2
  },
  "border-l-2": {
    "borderLeftWidth": 2
  },
  "border-r-2": {
    "borderRightWidth": 2
  },
  "border-x-2": {
    "borderLeftWidth": 2,
    "borderRightWidth": 2
  },
  "border-y-2": {
    "borderTopWidth": 2,
    "borderBottomWidth": 2
  },
  "border-4": {
    "borderWidth": 4
  },
  "border-t-4": {
    "borderTopWidth": 4
  },
  "border-b-4": {
    "borderBottomWidth": 4
  },
  "border-l-4": {
    "borderLeftWidth": 4
  },
  "border-r-4": {
    "borderRightWidth": 4
  },
  "border-x-4": {
    "borderLeftWidth": 4,
    "borderRightWidth": 4
  },
  "border-y-4": {
    "borderTopWidth": 4,
    "borderBottomWidth": 4
  },
  "border-8": {
    "borderWidth": 8
  },
  "border-t-8": {
    "borderTopWidth": 8
  },
  "border-b-8": {
    "borderBottomWidth": 8
  },
  "border-l-8": {
    "borderLeftWidth": 8
  },
  "border-r-8": {
    "borderRightWidth": 8
  },
  "border-x-8": {
    "borderLeftWidth": 8,
    "borderRightWidth": 8
  },
  "border-y-8": {
    "borderTopWidth": 8,
    "borderBottomWidth": 8
  },
  "cursor-auto": {
    "cursor": "auto"
  },
  "cursor-default": {
    "cursor": "default"
  },
  "cursor-pointer": {
    "cursor": "pointer"
  },
  "cursor-wait": {
    "cursor": "wait"
  },
  "cursor-text": {
    "cursor": "text"
  },
  "cursor-move": {
    "cursor": "move"
  },
  "cursor-help": {
    "cursor": "help"
  },
  "cursor-not-allowed": {
    "cursor": "not-allowed"
  },
  "debug": {
    "borderWidth": 1,
    "borderColor": "red",
    "borderStyle": "solid"
  },
  "hidden": {
    "display": "none"
  },
  "flex": {
    "display": "flex"
  },
  "block": {
    "display": "block"
  },
  "inline": {
    "display": "inline"
  },
  "grid": {
    "display": "grid"
  },
  "inline-block": {
    "display": "inline-block"
  },
  "inline-flex": {
    "display": "inline-flex"
  },
  "table": {
    "display": "table"
  },
  "table-caption": {
    "display": "table-caption"
  },
  "table-cell": {
    "display": "table-cell"
  },
  "table-column": {
    "display": "table-column"
  },
  "table-column-group": {
    "display": "table-column-group"
  },
  "table-footer-group": {
    "display": "table-footer-group"
  },
  "table-row-group": {
    "display": "table-row-group"
  },
  "table-row": {
    "display": "table-row"
  },
  "flex-0": {
    "flex": 0
  },
  "flex-1": {
    "flex": 1
  },
  "flex-row": {
    "flexDirection": "row"
  },
  "flex-row-reverse": {
    "flexDirection": "row-reverse"
  },
  "flex-column": {
    "flexDirection": "column"
  },
  "flex-column-reverse": {
    "flexDirection": "column-reverse"
  },
  "flex-grow-0": {
    "flexGrow": 0
  },
  "flex-grow-1": {
    "flexGrow": 1
  },
  "flex-shrink-0": {
    "flexShrink": 0
  },
  "flex-shrink-1": {
    "flexShrink": 1
  },
  "flex-wrap": {
    "flexWrap": "wrap"
  },
  "flex-wrap-reverse": {
    "flexWrap": "wrap-reverse"
  },
  "flex-wrap-none": {
    "flexWrap": "nowrap"
  },
  "text-xs": {
    "fontSize": 12
  },
  "text-sm": {
    "fontSize": 14
  },
  "text-base": {
    "fontSize": 16
  },
  "text-lg": {
    "fontSize": 18
  },
  "text-xl": {
    "fontSize": 20
  },
  "text-2xl": {
    "fontSize": 24
  },
  "text-3xl": {
    "fontSize": 30
  },
  "text-4xl": {
    "fontSize": 36
  },
  "text-5xl": {
    "fontSize": 48
  },
  "italic": {
    "fontStyle": "italic"
  },
  "no-italic": {
    "fontStyle": "normal"
  },
  "font-hairline": {
    "fontWeight": 100
  },
  "font-thin": {
    "fontWeight": 200
  },
  "font-light": {
    "fontWeight": 300
  },
  "font-normal": {
    "fontWeight": 400
  },
  "font-medium": {
    "fontWeight": 500
  },
  "font-semibold": {
    "fontWeight": 600
  },
  "font-bold": {
    "fontWeight": 700
  },
  "font-extrabold": {
    "fontWeight": 800
  },
  "font-black": {
    "fontWeight": 900
  },
  "h-0": {
    "height": 0
  },
  "h-1": {
    "height": 16
  },
  "h-2": {
    "height": 32
  },
  "h-3": {
    "height": 48
  },
  "h-4": {
    "height": 64
  },
  "h-5": {
    "height": 80
  },
  "h-6": {
    "height": 96
  },
  "h-8": {
    "height": 128
  },
  "h-10": {
    "height": 160
  },
  "h-12": {
    "height": 192
  },
  "h-16": {
    "height": 256
  },
  "h-24": {
    "height": 384
  },
  "h-32": {
    "height": 512
  },
  "h-48": {
    "height": 768
  },
  "h-64": {
    "height": 1024
  },
  "h-1px": {
    "height": 1
  },
  "h-1/2": {
    "height": "50%"
  },
  "h-1/3": {
    "height": "33.33333%"
  },
  "h-2/3": {
    "height": "66.66667%"
  },
  "h-1/4": {
    "height": "25%"
  },
  "h-3/4": {
    "height": "75%"
  },
  "h-1/5": {
    "height": "20%"
  },
  "h-2/5": {
    "height": "40%"
  },
  "h-3/5": {
    "height": "60%"
  },
  "h-4/5": {
    "height": "80%"
  },
  "h-full": {
    "height": "100%"
  },
  "h-a": {
    "height": "auto"
  },
  "justify-start": {
    "justifyContent": "flex-start"
  },
  "justify-end": {
    "justifyContent": "flex-end"
  },
  "justify-center": {
    "justifyContent": "center"
  },
  "justify-between": {
    "justifyContent": "space-between"
  },
  "justify-around": {
    "justifyContent": "space-around"
  },
  "justify-evenly": {
    "justifyContent": "space-evenly"
  },
  "tracking-tight": {
    "letterSpacing": -0.5
  },
  "tracking-normal": {
    "letterSpacing": 0
  },
  "tracking-wide": {
    "letterSpacing": 0.5
  },
  "leading-none": {
    "lineHeight": 16
  },
  "leading-tight": {
    "lineHeight": 20
  },
  "leading-normal": {
    "lineHeight": 24
  },
  "leading-loose": {
    "lineHeight": 32
  },
  "m-0": {
    "margin": 0
  },
  "mt-0": {
    "marginTop": 0
  },
  "mb-0": {
    "marginBottom": 0
  },
  "ml-0": {
    "marginLeft": 0
  },
  "mr-0": {
    "marginRight": 0
  },
  "mx-0": {
    "marginLeft": 0,
    "marginRight": 0
  },
  "my-0": {
    "marginTop": 0,
    "marginBottom": 0
  },
  "m-1": {
    "margin": 4
  },
  "mt-1": {
    "marginTop": 4
  },
  "mb-1": {
    "marginBottom": 4
  },
  "ml-1": {
    "marginLeft": 4
  },
  "mr-1": {
    "marginRight": 4
  },
  "mx-1": {
    "marginLeft": 4,
    "marginRight": 4
  },
  "my-1": {
    "marginTop": 4,
    "marginBottom": 4
  },
  "m-2": {
    "margin": 8
  },
  "mt-2": {
    "marginTop": 8
  },
  "mb-2": {
    "marginBottom": 8
  },
  "ml-2": {
    "marginLeft": 8
  },
  "mr-2": {
    "marginRight": 8
  },
  "mx-2": {
    "marginLeft": 8,
    "marginRight": 8
  },
  "my-2": {
    "marginTop": 8,
    "marginBottom": 8
  },
  "m-3": {
    "margin": 12
  },
  "mt-3": {
    "marginTop": 12
  },
  "mb-3": {
    "marginBottom": 12
  },
  "ml-3": {
    "marginLeft": 12
  },
  "mr-3": {
    "marginRight": 12
  },
  "mx-3": {
    "marginLeft": 12,
    "marginRight": 12
  },
  "my-3": {
    "marginTop": 12,
    "marginBottom": 12
  },
  "m-4": {
    "margin": 16
  },
  "mt-4": {
    "marginTop": 16
  },
  "mb-4": {
    "marginBottom": 16
  },
  "ml-4": {
    "marginLeft": 16
  },
  "mr-4": {
    "marginRight": 16
  },
  "mx-4": {
    "marginLeft": 16,
    "marginRight": 16
  },
  "my-4": {
    "marginTop": 16,
    "marginBottom": 16
  },
  "m-5": {
    "margin": 20
  },
  "mt-5": {
    "marginTop": 20
  },
  "mb-5": {
    "marginBottom": 20
  },
  "ml-5": {
    "marginLeft": 20
  },
  "mr-5": {
    "marginRight": 20
  },
  "mx-5": {
    "marginLeft": 20,
    "marginRight": 20
  },
  "my-5": {
    "marginTop": 20,
    "marginBottom": 20
  },
  "m-6": {
    "margin": 24
  },
  "mt-6": {
    "marginTop": 24
  },
  "mb-6": {
    "marginBottom": 24
  },
  "ml-6": {
    "marginLeft": 24
  },
  "mr-6": {
    "marginRight": 24
  },
  "mx-6": {
    "marginLeft": 24,
    "marginRight": 24
  },
  "my-6": {
    "marginTop": 24,
    "marginBottom": 24
  },
  "m-8": {
    "margin": 32
  },
  "mt-8": {
    "marginTop": 32
  },
  "mb-8": {
    "marginBottom": 32
  },
  "ml-8": {
    "marginLeft": 32
  },
  "mr-8": {
    "marginRight": 32
  },
  "mx-8": {
    "marginLeft": 32,
    "marginRight": 32
  },
  "my-8": {
    "marginTop": 32,
    "marginBottom": 32
  },
  "m-9": {
    "margin": 36
  },
  "mt-9": {
    "marginTop": 36
  },
  "mb-9": {
    "marginBottom": 36
  },
  "ml-9": {
    "marginLeft": 36
  },
  "mr-9": {
    "marginRight": 36
  },
  "mx-9": {
    "marginLeft": 36,
    "marginRight": 36
  },
  "my-9": {
    "marginTop": 36,
    "marginBottom": 36
  },
  "m-10": {
    "margin": 40
  },
  "mt-10": {
    "marginTop": 40
  },
  "mb-10": {
    "marginBottom": 40
  },
  "ml-10": {
    "marginLeft": 40
  },
  "mr-10": {
    "marginRight": 40
  },
  "mx-10": {
    "marginLeft": 40,
    "marginRight": 40
  },
  "my-10": {
    "marginTop": 40,
    "marginBottom": 40
  },
  "m-12": {
    "margin": 48
  },
  "mt-12": {
    "marginTop": 48
  },
  "mb-12": {
    "marginBottom": 48
  },
  "ml-12": {
    "marginLeft": 48
  },
  "mr-12": {
    "marginRight": 48
  },
  "mx-12": {
    "marginLeft": 48,
    "marginRight": 48
  },
  "my-12": {
    "marginTop": 48,
    "marginBottom": 48
  },
  "m-16": {
    "margin": 64
  },
  "mt-16": {
    "marginTop": 64
  },
  "mb-16": {
    "marginBottom": 64
  },
  "ml-16": {
    "marginLeft": 64
  },
  "mr-16": {
    "marginRight": 64
  },
  "mx-16": {
    "marginLeft": 64,
    "marginRight": 64
  },
  "my-16": {
    "marginTop": 64,
    "marginBottom": 64
  },
  "m-24": {
    "margin": 96
  },
  "mt-24": {
    "marginTop": 96
  },
  "mb-24": {
    "marginBottom": 96
  },
  "ml-24": {
    "marginLeft": 96
  },
  "mr-24": {
    "marginRight": 96
  },
  "mx-24": {
    "marginLeft": 96,
    "marginRight": 96
  },
  "my-24": {
    "marginTop": 96,
    "marginBottom": 96
  },
  "m-32": {
    "margin": 128
  },
  "mt-32": {
    "marginTop": 128
  },
  "mb-32": {
    "marginBottom": 128
  },
  "ml-32": {
    "marginLeft": 128
  },
  "mr-32": {
    "marginRight": 128
  },
  "mx-32": {
    "marginLeft": 128,
    "marginRight": 128
  },
  "my-32": {
    "marginTop": 128,
    "marginBottom": 128
  },
  "m-48": {
    "margin": 192
  },
  "mt-48": {
    "marginTop": 192
  },
  "mb-48": {
    "marginBottom": 192
  },
  "ml-48": {
    "marginLeft": 192
  },
  "mr-48": {
    "marginRight": 192
  },
  "mx-48": {
    "marginLeft": 192,
    "marginRight": 192
  },
  "my-48": {
    "marginTop": 192,
    "marginBottom": 192
  },
  "m-64": {
    "margin": 256
  },
  "mt-64": {
    "marginTop": 256
  },
  "mb-64": {
    "marginBottom": 256
  },
  "ml-64": {
    "marginLeft": 256
  },
  "mr-64": {
    "marginRight": 256
  },
  "mx-64": {
    "marginLeft": 256,
    "marginRight": 256
  },
  "my-64": {
    "marginTop": 256,
    "marginBottom": 256
  },
  "m-1px": {
    "margin": 1
  },
  "mt-1px": {
    "marginTop": 1
  },
  "mb-1px": {
    "marginBottom": 1
  },
  "ml-1px": {
    "marginLeft": 1
  },
  "mr-1px": {
    "marginRight": 1
  },
  "mx-1px": {
    "marginLeft": 1,
    "marginRight": 1
  },
  "my-1px": {
    "marginTop": 1,
    "marginBottom": 1
  },
  "m-1/2": {
    "margin": "50%"
  },
  "mt-1/2": {
    "marginTop": "50%"
  },
  "mb-1/2": {
    "marginBottom": "50%"
  },
  "ml-1/2": {
    "marginLeft": "50%"
  },
  "mr-1/2": {
    "marginRight": "50%"
  },
  "mx-1/2": {
    "marginLeft": "50%",
    "marginRight": "50%"
  },
  "my-1/2": {
    "marginTop": "50%",
    "marginBottom": "50%"
  },
  "m-1/3": {
    "margin": "33.33333%"
  },
  "mt-1/3": {
    "marginTop": "33.33333%"
  },
  "mb-1/3": {
    "marginBottom": "33.33333%"
  },
  "ml-1/3": {
    "marginLeft": "33.33333%"
  },
  "mr-1/3": {
    "marginRight": "33.33333%"
  },
  "mx-1/3": {
    "marginLeft": "33.33333%",
    "marginRight": "33.33333%"
  },
  "my-1/3": {
    "marginTop": "33.33333%",
    "marginBottom": "33.33333%"
  },
  "m-2/3": {
    "margin": "66.66667%"
  },
  "mt-2/3": {
    "marginTop": "66.66667%"
  },
  "mb-2/3": {
    "marginBottom": "66.66667%"
  },
  "ml-2/3": {
    "marginLeft": "66.66667%"
  },
  "mr-2/3": {
    "marginRight": "66.66667%"
  },
  "mx-2/3": {
    "marginLeft": "66.66667%",
    "marginRight": "66.66667%"
  },
  "my-2/3": {
    "marginTop": "66.66667%",
    "marginBottom": "66.66667%"
  },
  "m-1/4": {
    "margin": "25%"
  },
  "mt-1/4": {
    "marginTop": "25%"
  },
  "mb-1/4": {
    "marginBottom": "25%"
  },
  "ml-1/4": {
    "marginLeft": "25%"
  },
  "mr-1/4": {
    "marginRight": "25%"
  },
  "mx-1/4": {
    "marginLeft": "25%",
    "marginRight": "25%"
  },
  "my-1/4": {
    "marginTop": "25%",
    "marginBottom": "25%"
  },
  "m-3/4": {
    "margin": "75%"
  },
  "mt-3/4": {
    "marginTop": "75%"
  },
  "mb-3/4": {
    "marginBottom": "75%"
  },
  "ml-3/4": {
    "marginLeft": "75%"
  },
  "mr-3/4": {
    "marginRight": "75%"
  },
  "mx-3/4": {
    "marginLeft": "75%",
    "marginRight": "75%"
  },
  "my-3/4": {
    "marginTop": "75%",
    "marginBottom": "75%"
  },
  "m-1/5": {
    "margin": "20%"
  },
  "mt-1/5": {
    "marginTop": "20%"
  },
  "mb-1/5": {
    "marginBottom": "20%"
  },
  "ml-1/5": {
    "marginLeft": "20%"
  },
  "mr-1/5": {
    "marginRight": "20%"
  },
  "mx-1/5": {
    "marginLeft": "20%",
    "marginRight": "20%"
  },
  "my-1/5": {
    "marginTop": "20%",
    "marginBottom": "20%"
  },
  "m-2/5": {
    "margin": "40%"
  },
  "mt-2/5": {
    "marginTop": "40%"
  },
  "mb-2/5": {
    "marginBottom": "40%"
  },
  "ml-2/5": {
    "marginLeft": "40%"
  },
  "mr-2/5": {
    "marginRight": "40%"
  },
  "mx-2/5": {
    "marginLeft": "40%",
    "marginRight": "40%"
  },
  "my-2/5": {
    "marginTop": "40%",
    "marginBottom": "40%"
  },
  "m-3/5": {
    "margin": "60%"
  },
  "mt-3/5": {
    "marginTop": "60%"
  },
  "mb-3/5": {
    "marginBottom": "60%"
  },
  "ml-3/5": {
    "marginLeft": "60%"
  },
  "mr-3/5": {
    "marginRight": "60%"
  },
  "mx-3/5": {
    "marginLeft": "60%",
    "marginRight": "60%"
  },
  "my-3/5": {
    "marginTop": "60%",
    "marginBottom": "60%"
  },
  "m-4/5": {
    "margin": "80%"
  },
  "mt-4/5": {
    "marginTop": "80%"
  },
  "mb-4/5": {
    "marginBottom": "80%"
  },
  "ml-4/5": {
    "marginLeft": "80%"
  },
  "mr-4/5": {
    "marginRight": "80%"
  },
  "mx-4/5": {
    "marginLeft": "80%",
    "marginRight": "80%"
  },
  "my-4/5": {
    "marginTop": "80%",
    "marginBottom": "80%"
  },
  "m-a": {
    "margin": "auto"
  },
  "mt-a": {
    "marginTop": "auto"
  },
  "mb-a": {
    "marginBottom": "auto"
  },
  "ml-a": {
    "marginLeft": "auto"
  },
  "mr-a": {
    "marginRight": "auto"
  },
  "mx-a": {
    "marginLeft": "auto",
    "marginRight": "auto"
  },
  "my-a": {
    "marginTop": "auto",
    "marginBottom": "auto"
  },
  "max-h-0": {
    "maxHeight": 0
  },
  "max-h-1": {
    "maxHeight": 16
  },
  "max-h-2": {
    "maxHeight": 32
  },
  "max-h-3": {
    "maxHeight": 48
  },
  "max-h-4": {
    "maxHeight": 64
  },
  "max-h-5": {
    "maxHeight": 80
  },
  "max-h-6": {
    "maxHeight": 96
  },
  "max-h-8": {
    "maxHeight": 128
  },
  "max-h-10": {
    "maxHeight": 160
  },
  "max-h-12": {
    "maxHeight": 192
  },
  "max-h-16": {
    "maxHeight": 256
  },
  "max-h-24": {
    "maxHeight": 384
  },
  "max-h-32": {
    "maxHeight": 512
  },
  "max-h-48": {
    "maxHeight": 768
  },
  "max-h-64": {
    "maxHeight": 1024
  },
  "max-h-1px": {
    "maxHeight": 1
  },
  "max-h-1/2": {
    "maxHeight": "50%"
  },
  "max-h-1/3": {
    "maxHeight": "33.33333%"
  },
  "max-h-2/3": {
    "maxHeight": "66.66667%"
  },
  "max-h-1/4": {
    "maxHeight": "25%"
  },
  "max-h-3/4": {
    "maxHeight": "75%"
  },
  "max-h-1/5": {
    "maxHeight": "20%"
  },
  "max-h-2/5": {
    "maxHeight": "40%"
  },
  "max-h-3/5": {
    "maxHeight": "60%"
  },
  "max-h-4/5": {
    "maxHeight": "80%"
  },
  "max-h-full": {
    "maxHeight": "100%"
  },
  "max-h-a": {
    "maxHeight": "auto"
  },
  "max-w-0": {
    "maxWidth": 0
  },
  "max-w-1": {
    "maxWidth": 16
  },
  "max-w-2": {
    "maxWidth": 32
  },
  "max-w-3": {
    "maxWidth": 48
  },
  "max-w-4": {
    "maxWidth": 64
  },
  "max-w-5": {
    "maxWidth": 80
  },
  "max-w-6": {
    "maxWidth": 96
  },
  "max-w-8": {
    "maxWidth": 128
  },
  "max-w-10": {
    "maxWidth": 160
  },
  "max-w-12": {
    "maxWidth": 192
  },
  "max-w-16": {
    "maxWidth": 256
  },
  "max-w-24": {
    "maxWidth": 384
  },
  "max-w-32": {
    "maxWidth": 512
  },
  "max-w-48": {
    "maxWidth": 768
  },
  "max-w-64": {
    "maxWidth": 1024
  },
  "max-w-1px": {
    "maxWidth": 1
  },
  "max-w-1/2": {
    "maxWidth": "50%"
  },
  "max-w-1/3": {
    "maxWidth": "33.33333%"
  },
  "max-w-2/3": {
    "maxWidth": "66.66667%"
  },
  "max-w-1/4": {
    "maxWidth": "25%"
  },
  "max-w-3/4": {
    "maxWidth": "75%"
  },
  "max-w-1/5": {
    "maxWidth": "20%"
  },
  "max-w-2/5": {
    "maxWidth": "40%"
  },
  "max-w-3/5": {
    "maxWidth": "60%"
  },
  "max-w-4/5": {
    "maxWidth": "80%"
  },
  "max-w-full": {
    "maxWidth": "100%"
  },
  "max-w-a": {
    "maxWidth": "auto"
  },
  "min-h-0": {
    "minHeight": 0
  },
  "min-h-1": {
    "minHeight": 16
  },
  "min-h-2": {
    "minHeight": 32
  },
  "min-h-3": {
    "minHeight": 48
  },
  "min-h-4": {
    "minHeight": 64
  },
  "min-h-5": {
    "minHeight": 80
  },
  "min-h-6": {
    "minHeight": 96
  },
  "min-h-8": {
    "minHeight": 128
  },
  "min-h-10": {
    "minHeight": 160
  },
  "min-h-12": {
    "minHeight": 192
  },
  "min-h-16": {
    "minHeight": 256
  },
  "min-h-24": {
    "minHeight": 384
  },
  "min-h-32": {
    "minHeight": 512
  },
  "min-h-48": {
    "minHeight": 768
  },
  "min-h-64": {
    "minHeight": 1024
  },
  "min-h-1px": {
    "minHeight": 1
  },
  "min-h-1/2": {
    "minHeight": "50%"
  },
  "min-h-1/3": {
    "minHeight": "33.33333%"
  },
  "min-h-2/3": {
    "minHeight": "66.66667%"
  },
  "min-h-1/4": {
    "minHeight": "25%"
  },
  "min-h-3/4": {
    "minHeight": "75%"
  },
  "min-h-1/5": {
    "minHeight": "20%"
  },
  "min-h-2/5": {
    "minHeight": "40%"
  },
  "min-h-3/5": {
    "minHeight": "60%"
  },
  "min-h-4/5": {
    "minHeight": "80%"
  },
  "min-h-full": {
    "minHeight": "100%"
  },
  "min-h-a": {
    "minHeight": "auto"
  },
  "min-w-0": {
    "minWidth": 0
  },
  "min-w-1": {
    "minWidth": 16
  },
  "min-w-2": {
    "minWidth": 32
  },
  "min-w-3": {
    "minWidth": 48
  },
  "min-w-4": {
    "minWidth": 64
  },
  "min-w-5": {
    "minWidth": 80
  },
  "min-w-6": {
    "minWidth": 96
  },
  "min-w-8": {
    "minWidth": 128
  },
  "min-w-10": {
    "minWidth": 160
  },
  "min-w-12": {
    "minWidth": 192
  },
  "min-w-16": {
    "minWidth": 256
  },
  "min-w-24": {
    "minWidth": 384
  },
  "min-w-32": {
    "minWidth": 512
  },
  "min-w-48": {
    "minWidth": 768
  },
  "min-w-64": {
    "minWidth": 1024
  },
  "min-w-1px": {
    "minWidth": 1
  },
  "min-w-1/2": {
    "minWidth": "50%"
  },
  "min-w-1/3": {
    "minWidth": "33.33333%"
  },
  "min-w-2/3": {
    "minWidth": "66.66667%"
  },
  "min-w-1/4": {
    "minWidth": "25%"
  },
  "min-w-3/4": {
    "minWidth": "75%"
  },
  "min-w-1/5": {
    "minWidth": "20%"
  },
  "min-w-2/5": {
    "minWidth": "40%"
  },
  "min-w-3/5": {
    "minWidth": "60%"
  },
  "min-w-4/5": {
    "minWidth": "80%"
  },
  "min-w-full": {
    "minWidth": "100%"
  },
  "min-w-a": {
    "minWidth": "auto"
  },
  "object-contain": {
    "objectFit": "contain"
  },
  "object-cover": {
    "objectFit": "cover"
  },
  "object-fill": {
    "objectFit": "fill"
  },
  "object-none": {
    "objectFit": "none"
  },
  "object-scale-down": {
    "objectFit": "scale-down"
  },
  "p-0": {
    "padding": 0
  },
  "pt-0": {
    "paddingTop": 0
  },
  "pb-0": {
    "paddingBottom": 0
  },
  "pl-0": {
    "paddingLeft": 0
  },
  "pr-0": {
    "paddingRight": 0
  },
  "px-0": {
    "paddingLeft": 0,
    "paddingRight": 0
  },
  "py-0": {
    "paddingTop": 0,
    "paddingBottom": 0
  },
  "p-1": {
    "padding": 4
  },
  "pt-1": {
    "paddingTop": 4
  },
  "pb-1": {
    "paddingBottom": 4
  },
  "pl-1": {
    "paddingLeft": 4
  },
  "pr-1": {
    "paddingRight": 4
  },
  "px-1": {
    "paddingLeft": 4,
    "paddingRight": 4
  },
  "py-1": {
    "paddingTop": 4,
    "paddingBottom": 4
  },
  "p-2": {
    "padding": 8
  },
  "pt-2": {
    "paddingTop": 8
  },
  "pb-2": {
    "paddingBottom": 8
  },
  "pl-2": {
    "paddingLeft": 8
  },
  "pr-2": {
    "paddingRight": 8
  },
  "px-2": {
    "paddingLeft": 8,
    "paddingRight": 8
  },
  "py-2": {
    "paddingTop": 8,
    "paddingBottom": 8
  },
  "p-3": {
    "padding": 12
  },
  "pt-3": {
    "paddingTop": 12
  },
  "pb-3": {
    "paddingBottom": 12
  },
  "pl-3": {
    "paddingLeft": 12
  },
  "pr-3": {
    "paddingRight": 12
  },
  "px-3": {
    "paddingLeft": 12,
    "paddingRight": 12
  },
  "py-3": {
    "paddingTop": 12,
    "paddingBottom": 12
  },
  "p-4": {
    "padding": 16
  },
  "pt-4": {
    "paddingTop": 16
  },
  "pb-4": {
    "paddingBottom": 16
  },
  "pl-4": {
    "paddingLeft": 16
  },
  "pr-4": {
    "paddingRight": 16
  },
  "px-4": {
    "paddingLeft": 16,
    "paddingRight": 16
  },
  "py-4": {
    "paddingTop": 16,
    "paddingBottom": 16
  },
  "p-5": {
    "padding": 20
  },
  "pt-5": {
    "paddingTop": 20
  },
  "pb-5": {
    "paddingBottom": 20
  },
  "pl-5": {
    "paddingLeft": 20
  },
  "pr-5": {
    "paddingRight": 20
  },
  "px-5": {
    "paddingLeft": 20,
    "paddingRight": 20
  },
  "py-5": {
    "paddingTop": 20,
    "paddingBottom": 20
  },
  "p-6": {
    "padding": 24
  },
  "pt-6": {
    "paddingTop": 24
  },
  "pb-6": {
    "paddingBottom": 24
  },
  "pl-6": {
    "paddingLeft": 24
  },
  "pr-6": {
    "paddingRight": 24
  },
  "px-6": {
    "paddingLeft": 24,
    "paddingRight": 24
  },
  "py-6": {
    "paddingTop": 24,
    "paddingBottom": 24
  },
  "p-8": {
    "padding": 32
  },
  "pt-8": {
    "paddingTop": 32
  },
  "pb-8": {
    "paddingBottom": 32
  },
  "pl-8": {
    "paddingLeft": 32
  },
  "pr-8": {
    "paddingRight": 32
  },
  "px-8": {
    "paddingLeft": 32,
    "paddingRight": 32
  },
  "py-8": {
    "paddingTop": 32,
    "paddingBottom": 32
  },
  "p-9": {
    "padding": 36
  },
  "pt-9": {
    "paddingTop": 36
  },
  "pb-9": {
    "paddingBottom": 36
  },
  "pl-9": {
    "paddingLeft": 36
  },
  "pr-9": {
    "paddingRight": 36
  },
  "px-9": {
    "paddingLeft": 36,
    "paddingRight": 36
  },
  "py-9": {
    "paddingTop": 36,
    "paddingBottom": 36
  },
  "p-10": {
    "padding": 40
  },
  "pt-10": {
    "paddingTop": 40
  },
  "pb-10": {
    "paddingBottom": 40
  },
  "pl-10": {
    "paddingLeft": 40
  },
  "pr-10": {
    "paddingRight": 40
  },
  "px-10": {
    "paddingLeft": 40,
    "paddingRight": 40
  },
  "py-10": {
    "paddingTop": 40,
    "paddingBottom": 40
  },
  "p-12": {
    "padding": 48
  },
  "pt-12": {
    "paddingTop": 48
  },
  "pb-12": {
    "paddingBottom": 48
  },
  "pl-12": {
    "paddingLeft": 48
  },
  "pr-12": {
    "paddingRight": 48
  },
  "px-12": {
    "paddingLeft": 48,
    "paddingRight": 48
  },
  "py-12": {
    "paddingTop": 48,
    "paddingBottom": 48
  },
  "p-16": {
    "padding": 64
  },
  "pt-16": {
    "paddingTop": 64
  },
  "pb-16": {
    "paddingBottom": 64
  },
  "pl-16": {
    "paddingLeft": 64
  },
  "pr-16": {
    "paddingRight": 64
  },
  "px-16": {
    "paddingLeft": 64,
    "paddingRight": 64
  },
  "py-16": {
    "paddingTop": 64,
    "paddingBottom": 64
  },
  "p-24": {
    "padding": 96
  },
  "pt-24": {
    "paddingTop": 96
  },
  "pb-24": {
    "paddingBottom": 96
  },
  "pl-24": {
    "paddingLeft": 96
  },
  "pr-24": {
    "paddingRight": 96
  },
  "px-24": {
    "paddingLeft": 96,
    "paddingRight": 96
  },
  "py-24": {
    "paddingTop": 96,
    "paddingBottom": 96
  },
  "p-32": {
    "padding": 128
  },
  "pt-32": {
    "paddingTop": 128
  },
  "pb-32": {
    "paddingBottom": 128
  },
  "pl-32": {
    "paddingLeft": 128
  },
  "pr-32": {
    "paddingRight": 128
  },
  "px-32": {
    "paddingLeft": 128,
    "paddingRight": 128
  },
  "py-32": {
    "paddingTop": 128,
    "paddingBottom": 128
  },
  "p-48": {
    "padding": 192
  },
  "pt-48": {
    "paddingTop": 192
  },
  "pb-48": {
    "paddingBottom": 192
  },
  "pl-48": {
    "paddingLeft": 192
  },
  "pr-48": {
    "paddingRight": 192
  },
  "px-48": {
    "paddingLeft": 192,
    "paddingRight": 192
  },
  "py-48": {
    "paddingTop": 192,
    "paddingBottom": 192
  },
  "p-64": {
    "padding": 256
  },
  "pt-64": {
    "paddingTop": 256
  },
  "pb-64": {
    "paddingBottom": 256
  },
  "pl-64": {
    "paddingLeft": 256
  },
  "pr-64": {
    "paddingRight": 256
  },
  "px-64": {
    "paddingLeft": 256,
    "paddingRight": 256
  },
  "py-64": {
    "paddingTop": 256,
    "paddingBottom": 256
  },
  "p-1px": {
    "padding": 1
  },
  "pt-1px": {
    "paddingTop": 1
  },
  "pb-1px": {
    "paddingBottom": 1
  },
  "pl-1px": {
    "paddingLeft": 1
  },
  "pr-1px": {
    "paddingRight": 1
  },
  "px-1px": {
    "paddingLeft": 1,
    "paddingRight": 1
  },
  "py-1px": {
    "paddingTop": 1,
    "paddingBottom": 1
  },
  "p-1/2": {
    "padding": "50%"
  },
  "pt-1/2": {
    "paddingTop": "50%"
  },
  "pb-1/2": {
    "paddingBottom": "50%"
  },
  "pl-1/2": {
    "paddingLeft": "50%"
  },
  "pr-1/2": {
    "paddingRight": "50%"
  },
  "px-1/2": {
    "paddingLeft": "50%",
    "paddingRight": "50%"
  },
  "py-1/2": {
    "paddingTop": "50%",
    "paddingBottom": "50%"
  },
  "p-1/3": {
    "padding": "33.33333%"
  },
  "pt-1/3": {
    "paddingTop": "33.33333%"
  },
  "pb-1/3": {
    "paddingBottom": "33.33333%"
  },
  "pl-1/3": {
    "paddingLeft": "33.33333%"
  },
  "pr-1/3": {
    "paddingRight": "33.33333%"
  },
  "px-1/3": {
    "paddingLeft": "33.33333%",
    "paddingRight": "33.33333%"
  },
  "py-1/3": {
    "paddingTop": "33.33333%",
    "paddingBottom": "33.33333%"
  },
  "p-2/3": {
    "padding": "66.66667%"
  },
  "pt-2/3": {
    "paddingTop": "66.66667%"
  },
  "pb-2/3": {
    "paddingBottom": "66.66667%"
  },
  "pl-2/3": {
    "paddingLeft": "66.66667%"
  },
  "pr-2/3": {
    "paddingRight": "66.66667%"
  },
  "px-2/3": {
    "paddingLeft": "66.66667%",
    "paddingRight": "66.66667%"
  },
  "py-2/3": {
    "paddingTop": "66.66667%",
    "paddingBottom": "66.66667%"
  },
  "p-1/4": {
    "padding": "25%"
  },
  "pt-1/4": {
    "paddingTop": "25%"
  },
  "pb-1/4": {
    "paddingBottom": "25%"
  },
  "pl-1/4": {
    "paddingLeft": "25%"
  },
  "pr-1/4": {
    "paddingRight": "25%"
  },
  "px-1/4": {
    "paddingLeft": "25%",
    "paddingRight": "25%"
  },
  "py-1/4": {
    "paddingTop": "25%",
    "paddingBottom": "25%"
  },
  "p-3/4": {
    "padding": "75%"
  },
  "pt-3/4": {
    "paddingTop": "75%"
  },
  "pb-3/4": {
    "paddingBottom": "75%"
  },
  "pl-3/4": {
    "paddingLeft": "75%"
  },
  "pr-3/4": {
    "paddingRight": "75%"
  },
  "px-3/4": {
    "paddingLeft": "75%",
    "paddingRight": "75%"
  },
  "py-3/4": {
    "paddingTop": "75%",
    "paddingBottom": "75%"
  },
  "p-1/5": {
    "padding": "20%"
  },
  "pt-1/5": {
    "paddingTop": "20%"
  },
  "pb-1/5": {
    "paddingBottom": "20%"
  },
  "pl-1/5": {
    "paddingLeft": "20%"
  },
  "pr-1/5": {
    "paddingRight": "20%"
  },
  "px-1/5": {
    "paddingLeft": "20%",
    "paddingRight": "20%"
  },
  "py-1/5": {
    "paddingTop": "20%",
    "paddingBottom": "20%"
  },
  "p-2/5": {
    "padding": "40%"
  },
  "pt-2/5": {
    "paddingTop": "40%"
  },
  "pb-2/5": {
    "paddingBottom": "40%"
  },
  "pl-2/5": {
    "paddingLeft": "40%"
  },
  "pr-2/5": {
    "paddingRight": "40%"
  },
  "px-2/5": {
    "paddingLeft": "40%",
    "paddingRight": "40%"
  },
  "py-2/5": {
    "paddingTop": "40%",
    "paddingBottom": "40%"
  },
  "p-3/5": {
    "padding": "60%"
  },
  "pt-3/5": {
    "paddingTop": "60%"
  },
  "pb-3/5": {
    "paddingBottom": "60%"
  },
  "pl-3/5": {
    "paddingLeft": "60%"
  },
  "pr-3/5": {
    "paddingRight": "60%"
  },
  "px-3/5": {
    "paddingLeft": "60%",
    "paddingRight": "60%"
  },
  "py-3/5": {
    "paddingTop": "60%",
    "paddingBottom": "60%"
  },
  "p-4/5": {
    "padding": "80%"
  },
  "pt-4/5": {
    "paddingTop": "80%"
  },
  "pb-4/5": {
    "paddingBottom": "80%"
  },
  "pl-4/5": {
    "paddingLeft": "80%"
  },
  "pr-4/5": {
    "paddingRight": "80%"
  },
  "px-4/5": {
    "paddingLeft": "80%",
    "paddingRight": "80%"
  },
  "py-4/5": {
    "paddingTop": "80%",
    "paddingBottom": "80%"
  },
  "p-a": {
    "padding": "auto"
  },
  "pt-a": {
    "paddingTop": "auto"
  },
  "pb-a": {
    "paddingBottom": "auto"
  },
  "pl-a": {
    "paddingLeft": "auto"
  },
  "pr-a": {
    "paddingRight": "auto"
  },
  "px-a": {
    "paddingLeft": "auto",
    "paddingRight": "auto"
  },
  "py-a": {
    "paddingTop": "auto",
    "paddingBottom": "auto"
  },
  "absolute": {
    "position": "absolute"
  },
  "relative": {
    "position": "relative"
  },
  "static": {
    "position": "static"
  },
  "fixed": {
    "position": "fixed"
  },
  "sticky": {
    "position": "sticky"
  },
  "pin-0": {
    "top": 0,
    "right": 0,
    "bottom": 0,
    "left": 0
  },
  "pin-t-0": {
    "top": 0
  },
  "pin-r-0": {
    "right": 0
  },
  "pin-b-0": {
    "bottom": 0
  },
  "pin-l-0": {
    "left": 0
  },
  "pin-tl-0": {
    "top": 0,
    "left": 0
  },
  "pin-tr-0": {
    "top": 0,
    "right": 0
  },
  "pin-bl-0": {
    "bottom": 0,
    "left": 0
  },
  "pin-br-0": {
    "bottom": 0,
    "right": 0
  },
  "pin-x-0": {
    "left": 0,
    "right": 0
  },
  "pin-y-0": {
    "top": 0,
    "bottom": 0
  },
  "pin-1": {
    "top": 4,
    "right": 4,
    "bottom": 4,
    "left": 4
  },
  "pin-t-1": {
    "top": 4
  },
  "pin-r-1": {
    "right": 4
  },
  "pin-b-1": {
    "bottom": 4
  },
  "pin-l-1": {
    "left": 4
  },
  "pin-tl-1": {
    "top": 4,
    "left": 4
  },
  "pin-tr-1": {
    "top": 4,
    "right": 4
  },
  "pin-bl-1": {
    "bottom": 4,
    "left": 4
  },
  "pin-br-1": {
    "bottom": 4,
    "right": 4
  },
  "pin-x-1": {
    "left": 4,
    "right": 4
  },
  "pin-y-1": {
    "top": 4,
    "bottom": 4
  },
  "pin-2": {
    "top": 8,
    "right": 8,
    "bottom": 8,
    "left": 8
  },
  "pin-t-2": {
    "top": 8
  },
  "pin-r-2": {
    "right": 8
  },
  "pin-b-2": {
    "bottom": 8
  },
  "pin-l-2": {
    "left": 8
  },
  "pin-tl-2": {
    "top": 8,
    "left": 8
  },
  "pin-tr-2": {
    "top": 8,
    "right": 8
  },
  "pin-bl-2": {
    "bottom": 8,
    "left": 8
  },
  "pin-br-2": {
    "bottom": 8,
    "right": 8
  },
  "pin-x-2": {
    "left": 8,
    "right": 8
  },
  "pin-y-2": {
    "top": 8,
    "bottom": 8
  },
  "pin-3": {
    "top": 12,
    "right": 12,
    "bottom": 12,
    "left": 12
  },
  "pin-t-3": {
    "top": 12
  },
  "pin-r-3": {
    "right": 12
  },
  "pin-b-3": {
    "bottom": 12
  },
  "pin-l-3": {
    "left": 12
  },
  "pin-tl-3": {
    "top": 12,
    "left": 12
  },
  "pin-tr-3": {
    "top": 12,
    "right": 12
  },
  "pin-bl-3": {
    "bottom": 12,
    "left": 12
  },
  "pin-br-3": {
    "bottom": 12,
    "right": 12
  },
  "pin-x-3": {
    "left": 12,
    "right": 12
  },
  "pin-y-3": {
    "top": 12,
    "bottom": 12
  },
  "pin-4": {
    "top": 16,
    "right": 16,
    "bottom": 16,
    "left": 16
  },
  "pin-t-4": {
    "top": 16
  },
  "pin-r-4": {
    "right": 16
  },
  "pin-b-4": {
    "bottom": 16
  },
  "pin-l-4": {
    "left": 16
  },
  "pin-tl-4": {
    "top": 16,
    "left": 16
  },
  "pin-tr-4": {
    "top": 16,
    "right": 16
  },
  "pin-bl-4": {
    "bottom": 16,
    "left": 16
  },
  "pin-br-4": {
    "bottom": 16,
    "right": 16
  },
  "pin-x-4": {
    "left": 16,
    "right": 16
  },
  "pin-y-4": {
    "top": 16,
    "bottom": 16
  },
  "pin-5": {
    "top": 20,
    "right": 20,
    "bottom": 20,
    "left": 20
  },
  "pin-t-5": {
    "top": 20
  },
  "pin-r-5": {
    "right": 20
  },
  "pin-b-5": {
    "bottom": 20
  },
  "pin-l-5": {
    "left": 20
  },
  "pin-tl-5": {
    "top": 20,
    "left": 20
  },
  "pin-tr-5": {
    "top": 20,
    "right": 20
  },
  "pin-bl-5": {
    "bottom": 20,
    "left": 20
  },
  "pin-br-5": {
    "bottom": 20,
    "right": 20
  },
  "pin-x-5": {
    "left": 20,
    "right": 20
  },
  "pin-y-5": {
    "top": 20,
    "bottom": 20
  },
  "pin-6": {
    "top": 24,
    "right": 24,
    "bottom": 24,
    "left": 24
  },
  "pin-t-6": {
    "top": 24
  },
  "pin-r-6": {
    "right": 24
  },
  "pin-b-6": {
    "bottom": 24
  },
  "pin-l-6": {
    "left": 24
  },
  "pin-tl-6": {
    "top": 24,
    "left": 24
  },
  "pin-tr-6": {
    "top": 24,
    "right": 24
  },
  "pin-bl-6": {
    "bottom": 24,
    "left": 24
  },
  "pin-br-6": {
    "bottom": 24,
    "right": 24
  },
  "pin-x-6": {
    "left": 24,
    "right": 24
  },
  "pin-y-6": {
    "top": 24,
    "bottom": 24
  },
  "pin-8": {
    "top": 32,
    "right": 32,
    "bottom": 32,
    "left": 32
  },
  "pin-t-8": {
    "top": 32
  },
  "pin-r-8": {
    "right": 32
  },
  "pin-b-8": {
    "bottom": 32
  },
  "pin-l-8": {
    "left": 32
  },
  "pin-tl-8": {
    "top": 32,
    "left": 32
  },
  "pin-tr-8": {
    "top": 32,
    "right": 32
  },
  "pin-bl-8": {
    "bottom": 32,
    "left": 32
  },
  "pin-br-8": {
    "bottom": 32,
    "right": 32
  },
  "pin-x-8": {
    "left": 32,
    "right": 32
  },
  "pin-y-8": {
    "top": 32,
    "bottom": 32
  },
  "pin-10": {
    "top": 40,
    "right": 40,
    "bottom": 40,
    "left": 40
  },
  "pin-t-10": {
    "top": 40
  },
  "pin-r-10": {
    "right": 40
  },
  "pin-b-10": {
    "bottom": 40
  },
  "pin-l-10": {
    "left": 40
  },
  "pin-tl-10": {
    "top": 40,
    "left": 40
  },
  "pin-tr-10": {
    "top": 40,
    "right": 40
  },
  "pin-bl-10": {
    "bottom": 40,
    "left": 40
  },
  "pin-br-10": {
    "bottom": 40,
    "right": 40
  },
  "pin-x-10": {
    "left": 40,
    "right": 40
  },
  "pin-y-10": {
    "top": 40,
    "bottom": 40
  },
  "pin-12": {
    "top": 48,
    "right": 48,
    "bottom": 48,
    "left": 48
  },
  "pin-t-12": {
    "top": 48
  },
  "pin-r-12": {
    "right": 48
  },
  "pin-b-12": {
    "bottom": 48
  },
  "pin-l-12": {
    "left": 48
  },
  "pin-tl-12": {
    "top": 48,
    "left": 48
  },
  "pin-tr-12": {
    "top": 48,
    "right": 48
  },
  "pin-bl-12": {
    "bottom": 48,
    "left": 48
  },
  "pin-br-12": {
    "bottom": 48,
    "right": 48
  },
  "pin-x-12": {
    "left": 48,
    "right": 48
  },
  "pin-y-12": {
    "top": 48,
    "bottom": 48
  },
  "pin-16": {
    "top": 64,
    "right": 64,
    "bottom": 64,
    "left": 64
  },
  "pin-t-16": {
    "top": 64
  },
  "pin-r-16": {
    "right": 64
  },
  "pin-b-16": {
    "bottom": 64
  },
  "pin-l-16": {
    "left": 64
  },
  "pin-tl-16": {
    "top": 64,
    "left": 64
  },
  "pin-tr-16": {
    "top": 64,
    "right": 64
  },
  "pin-bl-16": {
    "bottom": 64,
    "left": 64
  },
  "pin-br-16": {
    "bottom": 64,
    "right": 64
  },
  "pin-x-16": {
    "left": 64,
    "right": 64
  },
  "pin-y-16": {
    "top": 64,
    "bottom": 64
  },
  "pin-24": {
    "top": 96,
    "right": 96,
    "bottom": 96,
    "left": 96
  },
  "pin-t-24": {
    "top": 96
  },
  "pin-r-24": {
    "right": 96
  },
  "pin-b-24": {
    "bottom": 96
  },
  "pin-l-24": {
    "left": 96
  },
  "pin-tl-24": {
    "top": 96,
    "left": 96
  },
  "pin-tr-24": {
    "top": 96,
    "right": 96
  },
  "pin-bl-24": {
    "bottom": 96,
    "left": 96
  },
  "pin-br-24": {
    "bottom": 96,
    "right": 96
  },
  "pin-x-24": {
    "left": 96,
    "right": 96
  },
  "pin-y-24": {
    "top": 96,
    "bottom": 96
  },
  "pin-32": {
    "top": 128,
    "right": 128,
    "bottom": 128,
    "left": 128
  },
  "pin-t-32": {
    "top": 128
  },
  "pin-r-32": {
    "right": 128
  },
  "pin-b-32": {
    "bottom": 128
  },
  "pin-l-32": {
    "left": 128
  },
  "pin-tl-32": {
    "top": 128,
    "left": 128
  },
  "pin-tr-32": {
    "top": 128,
    "right": 128
  },
  "pin-bl-32": {
    "bottom": 128,
    "left": 128
  },
  "pin-br-32": {
    "bottom": 128,
    "right": 128
  },
  "pin-x-32": {
    "left": 128,
    "right": 128
  },
  "pin-y-32": {
    "top": 128,
    "bottom": 128
  },
  "pin-48": {
    "top": 192,
    "right": 192,
    "bottom": 192,
    "left": 192
  },
  "pin-t-48": {
    "top": 192
  },
  "pin-r-48": {
    "right": 192
  },
  "pin-b-48": {
    "bottom": 192
  },
  "pin-l-48": {
    "left": 192
  },
  "pin-tl-48": {
    "top": 192,
    "left": 192
  },
  "pin-tr-48": {
    "top": 192,
    "right": 192
  },
  "pin-bl-48": {
    "bottom": 192,
    "left": 192
  },
  "pin-br-48": {
    "bottom": 192,
    "right": 192
  },
  "pin-x-48": {
    "left": 192,
    "right": 192
  },
  "pin-y-48": {
    "top": 192,
    "bottom": 192
  },
  "pin-64": {
    "top": 256,
    "right": 256,
    "bottom": 256,
    "left": 256
  },
  "pin-t-64": {
    "top": 256
  },
  "pin-r-64": {
    "right": 256
  },
  "pin-b-64": {
    "bottom": 256
  },
  "pin-l-64": {
    "left": 256
  },
  "pin-tl-64": {
    "top": 256,
    "left": 256
  },
  "pin-tr-64": {
    "top": 256,
    "right": 256
  },
  "pin-bl-64": {
    "bottom": 256,
    "left": 256
  },
  "pin-br-64": {
    "bottom": 256,
    "right": 256
  },
  "pin-x-64": {
    "left": 256,
    "right": 256
  },
  "pin-y-64": {
    "top": 256,
    "bottom": 256
  },
  "-pin-1": {
    "top": -4,
    "right": -4,
    "bottom": -4,
    "left": -4
  },
  "-pin-t-1": {
    "top": -4
  },
  "-pin-r-1": {
    "right": -4
  },
  "-pin-b-1": {
    "bottom": -4
  },
  "-pin-l-1": {
    "left": -4
  },
  "-pin-tl-1": {
    "top": -4,
    "left": -4
  },
  "-pin-tr-1": {
    "top": -4,
    "right": -4
  },
  "-pin-bl-1": {
    "bottom": -4,
    "left": -4
  },
  "-pin-br-1": {
    "bottom": -4,
    "right": -4
  },
  "-pin-x-1": {
    "left": -4,
    "right": -4
  },
  "-pin-y-1": {
    "top": -4,
    "bottom": -4
  },
  "-pin-2": {
    "top": -8,
    "right": -8,
    "bottom": -8,
    "left": -8
  },
  "-pin-t-2": {
    "top": -8
  },
  "-pin-r-2": {
    "right": -8
  },
  "-pin-b-2": {
    "bottom": -8
  },
  "-pin-l-2": {
    "left": -8
  },
  "-pin-tl-2": {
    "top": -8,
    "left": -8
  },
  "-pin-tr-2": {
    "top": -8,
    "right": -8
  },
  "-pin-bl-2": {
    "bottom": -8,
    "left": -8
  },
  "-pin-br-2": {
    "bottom": -8,
    "right": -8
  },
  "-pin-x-2": {
    "left": -8,
    "right": -8
  },
  "-pin-y-2": {
    "top": -8,
    "bottom": -8
  },
  "-pin-3": {
    "top": -12,
    "right": -12,
    "bottom": -12,
    "left": -12
  },
  "-pin-t-3": {
    "top": -12
  },
  "-pin-r-3": {
    "right": -12
  },
  "-pin-b-3": {
    "bottom": -12
  },
  "-pin-l-3": {
    "left": -12
  },
  "-pin-tl-3": {
    "top": -12,
    "left": -12
  },
  "-pin-tr-3": {
    "top": -12,
    "right": -12
  },
  "-pin-bl-3": {
    "bottom": -12,
    "left": -12
  },
  "-pin-br-3": {
    "bottom": -12,
    "right": -12
  },
  "-pin-x-3": {
    "left": -12,
    "right": -12
  },
  "-pin-y-3": {
    "top": -12,
    "bottom": -12
  },
  "-pin-4": {
    "top": -16,
    "right": -16,
    "bottom": -16,
    "left": -16
  },
  "-pin-t-4": {
    "top": -16
  },
  "-pin-r-4": {
    "right": -16
  },
  "-pin-b-4": {
    "bottom": -16
  },
  "-pin-l-4": {
    "left": -16
  },
  "-pin-tl-4": {
    "top": -16,
    "left": -16
  },
  "-pin-tr-4": {
    "top": -16,
    "right": -16
  },
  "-pin-bl-4": {
    "bottom": -16,
    "left": -16
  },
  "-pin-br-4": {
    "bottom": -16,
    "right": -16
  },
  "-pin-x-4": {
    "left": -16,
    "right": -16
  },
  "-pin-y-4": {
    "top": -16,
    "bottom": -16
  },
  "-pin-5": {
    "top": -20,
    "right": -20,
    "bottom": -20,
    "left": -20
  },
  "-pin-t-5": {
    "top": -20
  },
  "-pin-r-5": {
    "right": -20
  },
  "-pin-b-5": {
    "bottom": -20
  },
  "-pin-l-5": {
    "left": -20
  },
  "-pin-tl-5": {
    "top": -20,
    "left": -20
  },
  "-pin-tr-5": {
    "top": -20,
    "right": -20
  },
  "-pin-bl-5": {
    "bottom": -20,
    "left": -20
  },
  "-pin-br-5": {
    "bottom": -20,
    "right": -20
  },
  "-pin-x-5": {
    "left": -20,
    "right": -20
  },
  "-pin-y-5": {
    "top": -20,
    "bottom": -20
  },
  "-pin-6": {
    "top": -24,
    "right": -24,
    "bottom": -24,
    "left": -24
  },
  "-pin-t-6": {
    "top": -24
  },
  "-pin-r-6": {
    "right": -24
  },
  "-pin-b-6": {
    "bottom": -24
  },
  "-pin-l-6": {
    "left": -24
  },
  "-pin-tl-6": {
    "top": -24,
    "left": -24
  },
  "-pin-tr-6": {
    "top": -24,
    "right": -24
  },
  "-pin-bl-6": {
    "bottom": -24,
    "left": -24
  },
  "-pin-br-6": {
    "bottom": -24,
    "right": -24
  },
  "-pin-x-6": {
    "left": -24,
    "right": -24
  },
  "-pin-y-6": {
    "top": -24,
    "bottom": -24
  },
  "-pin-8": {
    "top": -32,
    "right": -32,
    "bottom": -32,
    "left": -32
  },
  "-pin-t-8": {
    "top": -32
  },
  "-pin-r-8": {
    "right": -32
  },
  "-pin-b-8": {
    "bottom": -32
  },
  "-pin-l-8": {
    "left": -32
  },
  "-pin-tl-8": {
    "top": -32,
    "left": -32
  },
  "-pin-tr-8": {
    "top": -32,
    "right": -32
  },
  "-pin-bl-8": {
    "bottom": -32,
    "left": -32
  },
  "-pin-br-8": {
    "bottom": -32,
    "right": -32
  },
  "-pin-x-8": {
    "left": -32,
    "right": -32
  },
  "-pin-y-8": {
    "top": -32,
    "bottom": -32
  },
  "-pin-10": {
    "top": -40,
    "right": -40,
    "bottom": -40,
    "left": -40
  },
  "-pin-t-10": {
    "top": -40
  },
  "-pin-r-10": {
    "right": -40
  },
  "-pin-b-10": {
    "bottom": -40
  },
  "-pin-l-10": {
    "left": -40
  },
  "-pin-tl-10": {
    "top": -40,
    "left": -40
  },
  "-pin-tr-10": {
    "top": -40,
    "right": -40
  },
  "-pin-bl-10": {
    "bottom": -40,
    "left": -40
  },
  "-pin-br-10": {
    "bottom": -40,
    "right": -40
  },
  "-pin-x-10": {
    "left": -40,
    "right": -40
  },
  "-pin-y-10": {
    "top": -40,
    "bottom": -40
  },
  "-pin-12": {
    "top": -48,
    "right": -48,
    "bottom": -48,
    "left": -48
  },
  "-pin-t-12": {
    "top": -48
  },
  "-pin-r-12": {
    "right": -48
  },
  "-pin-b-12": {
    "bottom": -48
  },
  "-pin-l-12": {
    "left": -48
  },
  "-pin-tl-12": {
    "top": -48,
    "left": -48
  },
  "-pin-tr-12": {
    "top": -48,
    "right": -48
  },
  "-pin-bl-12": {
    "bottom": -48,
    "left": -48
  },
  "-pin-br-12": {
    "bottom": -48,
    "right": -48
  },
  "-pin-x-12": {
    "left": -48,
    "right": -48
  },
  "-pin-y-12": {
    "top": -48,
    "bottom": -48
  },
  "-pin-16": {
    "top": -64,
    "right": -64,
    "bottom": -64,
    "left": -64
  },
  "-pin-t-16": {
    "top": -64
  },
  "-pin-r-16": {
    "right": -64
  },
  "-pin-b-16": {
    "bottom": -64
  },
  "-pin-l-16": {
    "left": -64
  },
  "-pin-tl-16": {
    "top": -64,
    "left": -64
  },
  "-pin-tr-16": {
    "top": -64,
    "right": -64
  },
  "-pin-bl-16": {
    "bottom": -64,
    "left": -64
  },
  "-pin-br-16": {
    "bottom": -64,
    "right": -64
  },
  "-pin-x-16": {
    "left": -64,
    "right": -64
  },
  "-pin-y-16": {
    "top": -64,
    "bottom": -64
  },
  "-pin-24": {
    "top": -96,
    "right": -96,
    "bottom": -96,
    "left": -96
  },
  "-pin-t-24": {
    "top": -96
  },
  "-pin-r-24": {
    "right": -96
  },
  "-pin-b-24": {
    "bottom": -96
  },
  "-pin-l-24": {
    "left": -96
  },
  "-pin-tl-24": {
    "top": -96,
    "left": -96
  },
  "-pin-tr-24": {
    "top": -96,
    "right": -96
  },
  "-pin-bl-24": {
    "bottom": -96,
    "left": -96
  },
  "-pin-br-24": {
    "bottom": -96,
    "right": -96
  },
  "-pin-x-24": {
    "left": -96,
    "right": -96
  },
  "-pin-y-24": {
    "top": -96,
    "bottom": -96
  },
  "-pin-32": {
    "top": -128,
    "right": -128,
    "bottom": -128,
    "left": -128
  },
  "-pin-t-32": {
    "top": -128
  },
  "-pin-r-32": {
    "right": -128
  },
  "-pin-b-32": {
    "bottom": -128
  },
  "-pin-l-32": {
    "left": -128
  },
  "-pin-tl-32": {
    "top": -128,
    "left": -128
  },
  "-pin-tr-32": {
    "top": -128,
    "right": -128
  },
  "-pin-bl-32": {
    "bottom": -128,
    "left": -128
  },
  "-pin-br-32": {
    "bottom": -128,
    "right": -128
  },
  "-pin-x-32": {
    "left": -128,
    "right": -128
  },
  "-pin-y-32": {
    "top": -128,
    "bottom": -128
  },
  "-pin-48": {
    "top": -192,
    "right": -192,
    "bottom": -192,
    "left": -192
  },
  "-pin-t-48": {
    "top": -192
  },
  "-pin-r-48": {
    "right": -192
  },
  "-pin-b-48": {
    "bottom": -192
  },
  "-pin-l-48": {
    "left": -192
  },
  "-pin-tl-48": {
    "top": -192,
    "left": -192
  },
  "-pin-tr-48": {
    "top": -192,
    "right": -192
  },
  "-pin-bl-48": {
    "bottom": -192,
    "left": -192
  },
  "-pin-br-48": {
    "bottom": -192,
    "right": -192
  },
  "-pin-x-48": {
    "left": -192,
    "right": -192
  },
  "-pin-y-48": {
    "top": -192,
    "bottom": -192
  },
  "-pin-64": {
    "top": -256,
    "right": -256,
    "bottom": -256,
    "left": -256
  },
  "-pin-t-64": {
    "top": -256
  },
  "-pin-r-64": {
    "right": -256
  },
  "-pin-b-64": {
    "bottom": -256
  },
  "-pin-l-64": {
    "left": -256
  },
  "-pin-tl-64": {
    "top": -256,
    "left": -256
  },
  "-pin-tr-64": {
    "top": -256,
    "right": -256
  },
  "-pin-bl-64": {
    "bottom": -256,
    "left": -256
  },
  "-pin-br-64": {
    "bottom": -256,
    "right": -256
  },
  "-pin-x-64": {
    "left": -256,
    "right": -256
  },
  "-pin-y-64": {
    "top": -256,
    "bottom": -256
  },
  "shadow-none": {
    "boxShadow": "none"
  },
  "shadow-xs": {
    "boxShadow": "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
  },
  "shadow-sm": {
    "boxShadow": "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)"
  },
  "shadow-md": {
    "boxShadow": "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
  },
  "shadow-lg": {
    "boxShadow": "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
  },
  "shadow-xl": {
    "boxShadow": "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
  },
  "shadow-2xl": {
    "boxShadow": "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
  },
  "text-left": {
    "textAlign": "left"
  },
  "text-right": {
    "textAlign": "right"
  },
  "text-center": {
    "textAlign": "center"
  },
  "text-transparent": {
    "color": "transparent"
  },
  "text-white": {
    "color": "white"
  },
  "text-black": {
    "color": "black"
  },
  "text-gray-50": {
    "color": "#FAFAFA"
  },
  "text-gray-100": {
    "color": "#F4F4F5"
  },
  "text-gray-200": {
    "color": "#E4E4E7"
  },
  "text-gray-300": {
    "color": "#D4D4D8"
  },
  "text-gray-400": {
    "color": "#A1A1AA"
  },
  "text-gray-500": {
    "color": "#71717A"
  },
  "text-gray-600": {
    "color": "#52525B"
  },
  "text-gray-700": {
    "color": "#3F3F46"
  },
  "text-gray-800": {
    "color": "#27272A"
  },
  "text-gray-900": {
    "color": "#18181B"
  },
  "text-rose-50": {
    "color": "#fff1f2"
  },
  "text-rose-100": {
    "color": "#ffe4e6"
  },
  "text-rose-200": {
    "color": "#fecdd3"
  },
  "text-rose-300": {
    "color": "#fda4af"
  },
  "text-rose-400": {
    "color": "#fb7185"
  },
  "text-rose-500": {
    "color": "#f43f5e"
  },
  "text-rose-600": {
    "color": "#e11d48"
  },
  "text-rose-700": {
    "color": "#be123c"
  },
  "text-rose-800": {
    "color": "#9f1239"
  },
  "text-rose-900": {
    "color": "#881337"
  },
  "text-pink-50": {
    "color": "#fdf2f8"
  },
  "text-pink-100": {
    "color": "#fce7f3"
  },
  "text-pink-200": {
    "color": "#fbcfe8"
  },
  "text-pink-300": {
    "color": "#f9a8d4"
  },
  "text-pink-400": {
    "color": "#f472b6"
  },
  "text-pink-500": {
    "color": "#ec4899"
  },
  "text-pink-600": {
    "color": "#db2777"
  },
  "text-pink-700": {
    "color": "#be185d"
  },
  "text-pink-800": {
    "color": "#9d174d"
  },
  "text-pink-900": {
    "color": "#831843"
  },
  "text-fuchsia-50": {
    "color": "#fdf4ff"
  },
  "text-fuchsia-100": {
    "color": "#fae8ff"
  },
  "text-fuchsia-200": {
    "color": "#f5d0fe"
  },
  "text-fuchsia-300": {
    "color": "#f0abfc"
  },
  "text-fuchsia-400": {
    "color": "#e879f9"
  },
  "text-fuchsia-500": {
    "color": "#d946ef"
  },
  "text-fuchsia-600": {
    "color": "#c026d3"
  },
  "text-fuchsia-700": {
    "color": "#a21caf"
  },
  "text-fuchsia-800": {
    "color": "#86198f"
  },
  "text-fuchsia-900": {
    "color": "#701a75"
  },
  "text-purple-50": {
    "color": "#faf5ff"
  },
  "text-purple-100": {
    "color": "#f3e8ff"
  },
  "text-purple-200": {
    "color": "#e9d5ff"
  },
  "text-purple-300": {
    "color": "#d8b4fe"
  },
  "text-purple-400": {
    "color": "#c084fc"
  },
  "text-purple-500": {
    "color": "#a855f7"
  },
  "text-purple-600": {
    "color": "#9333ea"
  },
  "text-purple-700": {
    "color": "#7e22ce"
  },
  "text-purple-800": {
    "color": "#6b21a8"
  },
  "text-purple-900": {
    "color": "#581c87"
  },
  "text-violet-50": {
    "color": "#f5f3ff"
  },
  "text-violet-100": {
    "color": "#ede9fe"
  },
  "text-violet-200": {
    "color": "#ddd6fe"
  },
  "text-violet-300": {
    "color": "#c4b5fd"
  },
  "text-violet-400": {
    "color": "#a78bfa"
  },
  "text-violet-500": {
    "color": "#8b5cf6"
  },
  "text-violet-600": {
    "color": "#7c3aed"
  },
  "text-violet-700": {
    "color": "#6d28d9"
  },
  "text-violet-800": {
    "color": "#5b21b6"
  },
  "text-violet-900": {
    "color": "#4c1d95"
  },
  "text-indigo-50": {
    "color": "#eef2ff"
  },
  "text-indigo-100": {
    "color": "#e0e7ff"
  },
  "text-indigo-200": {
    "color": "#c7d2fe"
  },
  "text-indigo-300": {
    "color": "#a5b4fc"
  },
  "text-indigo-400": {
    "color": "#818cf8"
  },
  "text-indigo-500": {
    "color": "#6366f1"
  },
  "text-indigo-600": {
    "color": "#4f46e5"
  },
  "text-indigo-700": {
    "color": "#4338ca"
  },
  "text-indigo-800": {
    "color": "#3730a3"
  },
  "text-indigo-900": {
    "color": "#312e81"
  },
  "text-blue-50": {
    "color": "#eff6ff"
  },
  "text-blue-100": {
    "color": "#dbeafe"
  },
  "text-blue-200": {
    "color": "#bfdbfe"
  },
  "text-blue-300": {
    "color": "#93c5fd"
  },
  "text-blue-400": {
    "color": "#60a5fa"
  },
  "text-blue-500": {
    "color": "#3b82f6"
  },
  "text-blue-600": {
    "color": "#2563eb"
  },
  "text-blue-700": {
    "color": "#1d4ed8"
  },
  "text-blue-800": {
    "color": "#1e40af"
  },
  "text-blue-900": {
    "color": "#1e3a8a"
  },
  "text-lightBlue-50": {
    "color": "#f0f9ff"
  },
  "text-lightBlue-100": {
    "color": "#e0f2fe"
  },
  "text-lightBlue-200": {
    "color": "#bae6fd"
  },
  "text-lightBlue-300": {
    "color": "#7dd3fc"
  },
  "text-lightBlue-400": {
    "color": "#38bdf8"
  },
  "text-lightBlue-500": {
    "color": "#0ea5e9"
  },
  "text-lightBlue-600": {
    "color": "#0284c7"
  },
  "text-lightBlue-700": {
    "color": "#0369a1"
  },
  "text-lightBlue-800": {
    "color": "#075985"
  },
  "text-lightBlue-900": {
    "color": "#0c4a6e"
  },
  "text-cyan-50": {
    "color": "#ecfeff"
  },
  "text-cyan-100": {
    "color": "#cffafe"
  },
  "text-cyan-200": {
    "color": "#a5f3fc"
  },
  "text-cyan-300": {
    "color": "#67e8f9"
  },
  "text-cyan-400": {
    "color": "#22d3ee"
  },
  "text-cyan-500": {
    "color": "#06b6d4"
  },
  "text-cyan-600": {
    "color": "#0891b2"
  },
  "text-cyan-700": {
    "color": "#0e7490"
  },
  "text-cyan-800": {
    "color": "#155e75"
  },
  "text-cyan-900": {
    "color": "#164e63"
  },
  "text-teal-50": {
    "color": "#f0fdfa"
  },
  "text-teal-100": {
    "color": "#ccfbf1"
  },
  "text-teal-200": {
    "color": "#99f6e4"
  },
  "text-teal-300": {
    "color": "#5eead4"
  },
  "text-teal-400": {
    "color": "#2dd4bf"
  },
  "text-teal-500": {
    "color": "#14b8a6"
  },
  "text-teal-600": {
    "color": "#0d9488"
  },
  "text-teal-700": {
    "color": "#0f766e"
  },
  "text-teal-800": {
    "color": "#115e59"
  },
  "text-teal-900": {
    "color": "#134e4a"
  },
  "text-emerald-50": {
    "color": "#ecfdf5"
  },
  "text-emerald-100": {
    "color": "#d1fae5"
  },
  "text-emerald-200": {
    "color": "#a7f3d0"
  },
  "text-emerald-300": {
    "color": "#6ee7b7"
  },
  "text-emerald-400": {
    "color": "#34d399"
  },
  "text-emerald-500": {
    "color": "#10b981"
  },
  "text-emerald-600": {
    "color": "#059669"
  },
  "text-emerald-700": {
    "color": "#047857"
  },
  "text-emerald-800": {
    "color": "#065f46"
  },
  "text-emerald-900": {
    "color": "#064e3b"
  },
  "text-green-50": {
    "color": "#f0fdf4"
  },
  "text-green-100": {
    "color": "#dcfce7"
  },
  "text-green-200": {
    "color": "#bbf7d0"
  },
  "text-green-300": {
    "color": "#86efac"
  },
  "text-green-400": {
    "color": "#4ade80"
  },
  "text-green-500": {
    "color": "#22c55e"
  },
  "text-green-600": {
    "color": "#16a34a"
  },
  "text-green-700": {
    "color": "#15803d"
  },
  "text-green-800": {
    "color": "#166534"
  },
  "text-green-900": {
    "color": "#14532d"
  },
  "text-lime-50": {
    "color": "#f7fee7"
  },
  "text-lime-100": {
    "color": "#ecfccb"
  },
  "text-lime-200": {
    "color": "#d9f99d"
  },
  "text-lime-300": {
    "color": "#bef264"
  },
  "text-lime-400": {
    "color": "#a3e635"
  },
  "text-lime-500": {
    "color": "#84cc16"
  },
  "text-lime-600": {
    "color": "#65a30d"
  },
  "text-lime-700": {
    "color": "#4d7c0f"
  },
  "text-lime-800": {
    "color": "#3f6212"
  },
  "text-lime-900": {
    "color": "#365314"
  },
  "text-yellow-50": {
    "color": "#fefce8"
  },
  "text-yellow-100": {
    "color": "#fef9c3"
  },
  "text-yellow-200": {
    "color": "#fef08a"
  },
  "text-yellow-300": {
    "color": "#fde047"
  },
  "text-yellow-400": {
    "color": "#facc15"
  },
  "text-yellow-500": {
    "color": "#eab308"
  },
  "text-yellow-600": {
    "color": "#ca8a04"
  },
  "text-yellow-700": {
    "color": "#a16207"
  },
  "text-yellow-800": {
    "color": "#854d0e"
  },
  "text-yellow-900": {
    "color": "#713f12"
  },
  "text-amber-50": {
    "color": "#fffbeb"
  },
  "text-amber-100": {
    "color": "#fef3c7"
  },
  "text-amber-200": {
    "color": "#fde68a"
  },
  "text-amber-300": {
    "color": "#fcd34d"
  },
  "text-amber-400": {
    "color": "#fbbf24"
  },
  "text-amber-500": {
    "color": "#f59e0b"
  },
  "text-amber-600": {
    "color": "#d97706"
  },
  "text-amber-700": {
    "color": "#b45309"
  },
  "text-amber-800": {
    "color": "#92400e"
  },
  "text-amber-900": {
    "color": "#78350f"
  },
  "text-orange-50": {
    "color": "#fff7ed"
  },
  "text-orange-100": {
    "color": "#ffedd5"
  },
  "text-orange-200": {
    "color": "#fed7aa"
  },
  "text-orange-300": {
    "color": "#fdba74"
  },
  "text-orange-400": {
    "color": "#fb923c"
  },
  "text-orange-500": {
    "color": "#f97316"
  },
  "text-orange-600": {
    "color": "#ea580c"
  },
  "text-orange-700": {
    "color": "#c2410c"
  },
  "text-orange-800": {
    "color": "#9a3412"
  },
  "text-orange-900": {
    "color": "#7c2d12"
  },
  "text-red-50": {
    "color": "#fef2f2"
  },
  "text-red-100": {
    "color": "#fee2e2"
  },
  "text-red-200": {
    "color": "#fecaca"
  },
  "text-red-300": {
    "color": "#fca5a5"
  },
  "text-red-400": {
    "color": "#f87171"
  },
  "text-red-500": {
    "color": "#ef4444"
  },
  "text-red-600": {
    "color": "#dc2626"
  },
  "text-red-700": {
    "color": "#b91c1c"
  },
  "text-red-800": {
    "color": "#991b1b"
  },
  "text-red-900": {
    "color": "#7f1d1d"
  },
  "text-grey-50": {
    "color": "#FBFBFB"
  },
  "text-grey-100": {
    "color": "#F2F3F2"
  },
  "text-grey-200": {
    "color": "#E4E6E6"
  },
  "text-grey-300": {
    "color": "#D7DAD9"
  },
  "text-grey-400": {
    "color": "C9CECD"
  },
  "text-grey-500": {
    "color": "#A5ADAB"
  },
  "text-grey-600": {
    "color": "#798582"
  },
  "text-grey-700": {
    "color": "#515856"
  },
  "text-grey-800": {
    "color": "#282C2B"
  },
  "text-grey-900": {
    "color": "#141616"
  },
  "text-error": {
    "color": "#F35A56"
  },
  "no-decoration": {
    "textDecorationLine": "none"
  },
  "underline": {
    "textDecorationLine": "underline"
  },
  "line-through": {
    "textDecorationLine": "line-through"
  },
  "normal-case": {
    "textTransform": "none"
  },
  "uppercase": {
    "textTransform": "uppercase"
  },
  "lowercase": {
    "textTransform": "lowercase"
  },
  "capitalize": {
    "textTransform": "capitalize"
  },
  "align-baseline": {
    "verticalAlign": "baseline"
  },
  "align-top": {
    "verticalAlign": "top"
  },
  "align-middle": {
    "verticalAlign": "middle"
  },
  "align-bottom": {
    "verticalAlign": "bottom"
  },
  "align-text-top": {
    "verticalAlign": "text-top"
  },
  "align-text-bottom": {
    "verticalAlign": "text-bottom"
  },
  "w-0": {
    "width": 0
  },
  "w-1": {
    "width": 16
  },
  "w-2": {
    "width": 32
  },
  "w-3": {
    "width": 48
  },
  "w-4": {
    "width": 64
  },
  "w-5": {
    "width": 80
  },
  "w-6": {
    "width": 96
  },
  "w-8": {
    "width": 128
  },
  "w-10": {
    "width": 160
  },
  "w-12": {
    "width": 192
  },
  "w-16": {
    "width": 256
  },
  "w-24": {
    "width": 384
  },
  "w-32": {
    "width": 512
  },
  "w-48": {
    "width": 768
  },
  "w-64": {
    "width": 1024
  },
  "w-1px": {
    "width": 1
  },
  "w-1/2": {
    "width": "50%"
  },
  "w-1/3": {
    "width": "33.33333%"
  },
  "w-2/3": {
    "width": "66.66667%"
  },
  "w-1/4": {
    "width": "25%"
  },
  "w-3/4": {
    "width": "75%"
  },
  "w-1/5": {
    "width": "20%"
  },
  "w-2/5": {
    "width": "40%"
  },
  "w-3/5": {
    "width": "60%"
  },
  "w-4/5": {
    "width": "80%"
  },
  "w-full": {
    "width": "100%"
  },
  "w-a": {
    "width": "auto"
  },
  "z-0": {
    "zIndex": 0
  },
  "z-1": {
    "zIndex": 1
  },
  "z-2": {
    "zIndex": 2
  },
  "z-3": {
    "zIndex": 3
  },
  "z-4": {
    "zIndex": 4
  },
  "z-5": {
    "zIndex": 5
  }
});

function s(utilities) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof utilities !== 'string') {
    throw new TypeError("TypeError [headwind]: expected utilities to be a 'string', got '".concat(_typeof(utilities), "' instead"));
  }

  if (_typeof(overrides) !== 'object') {
    throw new TypeError("TypeError [headwind]: expected overrides to be an 'object', got '".concat(_typeof(overrides), "' instead"));
  }

  var styles = utilities.split(' ').reduce(function (acc, utility) {
    return Object.assign(acc, headwindUtilities[utility] || {});
  }, {});
  return Object.assign(styles, overrides);
}

/** @type {import('./types').GlobalStyles} */
var defaultGlobalStyles = {
  containerStyles: {
    backgroundColor: '#282c34'
  },
  innerContainerStyles: {},
  inputStyles: {},
  helperTextStyles: {},
  headingStyles: {},
  buttonStyles: {},
  innerLinkStyles: {}
};
var getGlobalStyles = function getGlobalStyles(customStyles) {
  return _objectSpread2(_objectSpread2({}, defaultGlobalStyles), customStyles);
};

var DataContext = /*#__PURE__*/React.createContext({});
var DataProviderBase = DataContext.Provider;
/**
 *
 * @typedef {Object} StyleProps
 * @property {import('../types').GlobalStyles} globalStyles
 * @property {boolean} allowSelfSignUp - Allow user sign up themselves
 */

/** @returns {StyleProps} */

function useData() {
  return useContext(DataContext);
}
/**
 *
 * @typedef {Object} Props
 * @property {Object} children - React children component
 * @property {import('../types').GlobalStyles} globalStyles
 * @property {boolean} allowSelfSignUp - Allow user sign up themselves
 */

/** @param {Props} props */


function DataProvider(_ref) {
  var children = _ref.children,
      customStyles = _ref.customStyles,
      allowSelfSignUp = _ref.allowSelfSignUp;
  return /*#__PURE__*/React.createElement(DataProviderBase, {
    value: {
      globalStyles: getGlobalStyles(customStyles),
      allowSelfSignUp: allowSelfSignUp
    }
  }, children);
}

var ButtonBase = styled.button(s('flex w-full h-3 items-center justify-center text-white rounded-md text-base font-normal py-4 border-0 font-semibold'), {
  borderRadius: 6,
  transition: 'all 250ms',
  '&:focus': {
    outline: '-webkit-focus-ring-color auto 5px'
  },
  '&:hover': s('shadow-none', {
    cursor: 'pointer',
    backgroundColor: '#ff3030'
  }),
  '&:disabled': {
    background: '#ff5530b8',
    color: 'white',
    cursor: 'default'
  }
}, function (_ref) {
  var buttonStyles = _ref.buttonStyles;
  return buttonStyles;
});

function Button(_ref2) {
  var props = _extends({}, _ref2);

  var _useData = useData(),
      buttonStyles = _useData.globalStyles.buttonStyles;

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    type: "button"
  }, props, {
    buttonStyles: buttonStyles
  }));
}

var _excluded$7 = ["children"];
var HeadingBase = styled.h2(s('mb-6', {
  fontSize: '1.8rem',
  '@media (min-width: 1280px)': {
    fontSize: '2.2rem'
  }
}), prop('headingStyles'));

function Heading(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children,
      otherProps = _objectWithoutProperties(_ref, _excluded$7);

  var _useData = useData(),
      headingStyles = _useData.globalStyles.headingStyles;

  return /*#__PURE__*/React.createElement(HeadingBase, _extends({
    headingStyles: headingStyles
  }, otherProps), children);
}

var handleAuthError = function handleAuthError(error) {
  Hub.dispatch(UI_AUTH_CHANNEL, {
    event: TOAST_AUTH_ERROR_EVENT,
    message: I18n.get(error.message)
  });
};

var handleAuthStateChange = function handleAuthStateChange(nextAuthState, data) {
  Hub.dispatch(UI_AUTH_CHANNEL, {
    event: AUTH_STATE_CHANGE_EVENT,
    message: nextAuthState,
    data: data
  });
};

function checkContact(_x, _x2) {
  return _checkContact.apply(this, arguments);
}

function _checkContact() {
  _checkContact = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user, handleAuthStateChange) {
    var data, newUser;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (user instanceof CognitoUser) {
              _context.next = 3;
              break;
            }

            handleAuthStateChange(AuthState.SignedIn, user);
            return _context.abrupt("return");

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return Auth.verifiedContact(user);

          case 6:
            data = _context.sent;

            if (!isEmpty(data.verified) || isEmpty(data.unverified)) {
              handleAuthStateChange(AuthState.SignedIn, user);
            } else {
              newUser = Object.assign(user, data);
              handleAuthStateChange(AuthState.VerifyContact, newUser);
            }

            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            handleAuthError(_context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _checkContact.apply(this, arguments);
}

function handleSignIn(_x) {
  return _handleSignIn.apply(this, arguments);
}

function _handleSignIn() {
  _handleSignIn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var email, password, user;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            email = _ref.email, password = _ref.password;
            _context.prev = 1;
            _context.next = 4;
            return Auth.signIn(email, password);

          case 4:
            user = _context.sent;

            if (!(user.challengeName === ChallengeName.SMSMFA || user.challengeName === ChallengeName.SoftwareTokenMFA)) {
              _context.next = 9;
              break;
            }

            handleAuthStateChange(AuthState.ConfirmSignIn, user);
            _context.next = 23;
            break;

          case 9:
            if (!(user.challengeName === ChallengeName.NewPasswordRequired)) {
              _context.next = 13;
              break;
            }

            handleAuthStateChange(AuthState.ResetPassword, user);
            _context.next = 23;
            break;

          case 13:
            if (!(user.challengeName === ChallengeName.MFASetup)) {
              _context.next = 17;
              break;
            }

            handleAuthStateChange(AuthState.TOTPSetup, user);
            _context.next = 23;
            break;

          case 17:
            if (!(user.challengeName === ChallengeName.CustomChallenge && user.challengeParam && user.challengeParam.trigger === 'true')) {
              _context.next = 21;
              break;
            }

            handleAuthStateChange(AuthState.CustomConfirmSignIn, user);
            _context.next = 23;
            break;

          case 21:
            _context.next = 23;
            return checkContact(user, handleAuthStateChange);

          case 23:
            _context.next = 29;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](1);

            if (_context.t0.code === 'UserNotConfirmedException') {
              handleAuthStateChange(AuthState.ConfirmSignUp, {
                username: email
              });
            } else if (_context.t0.code === 'PasswordResetRequiredException') {
              handleAuthStateChange(AuthState.ForgotPassword, {
                username: email
              });
            } else if (_context.t0.code === 'InvalidParameterException' && password === '') {
              _context.t0.message = 'Password cannot be empty';
            }

            handleAuthError(_context.t0);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 25]]);
  }));
  return _handleSignIn.apply(this, arguments);
}

function dispatchNewUserEvent(event, user) {
  Hub.dispatch('newUser', {
    event: event,
    data: {
      user: user
    }
  });
}

var _excluded$6 = ["children"];
var HelperTextBase = styled.span(s('text-sm'), prop('helperTextStyles'));

function HelperText(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children,
      otherProps = _objectWithoutProperties(_ref, _excluded$6);

  var _useData = useData(),
      helperTextStyles = _useData.globalStyles.helperTextStyles;

  return /*#__PURE__*/React.createElement(HelperTextBase, _extends({
    helperTextStyles: helperTextStyles
  }, otherProps), children);
}

var _excluded$5 = ["children"];
var Container$3 = styled.div(s('flex flex-column justify-center rounded-md w-full px-4 py-12', {
  maxWidth: 450
}, function (_ref) {
  var innerContainerStyles = _ref.innerContainerStyles;
  return innerContainerStyles;
}));

function InnerContainer(_ref2) {
  var children = _ref2.children,
      otherProps = _objectWithoutProperties(_ref2, _excluded$5);

  var _useData = useData(),
      innerContainerStyles = _useData.globalStyles.innerContainerStyles;

  return /*#__PURE__*/React.createElement(Container$3, _extends({
    innerContainerStyles: innerContainerStyles
  }, otherProps), children);
}

var img$2 = "data:image/svg+xml,%3csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.9987 13.1663L5.33203 8.49967L9.9987 3.83301' stroke='%23490B2D' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var _excluded$4 = ["children", "showLeftChevron"];
var InnerLinkBase = styled.a(s('font-semibold flex items-center', {
  color: '#ff5530',
  cursor: 'pointer'
}), prop('innerLinkStyles'));

function InnerLink(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children,
      _ref$showLeftChevron = _ref.showLeftChevron,
      showLeftChevron = _ref$showLeftChevron === void 0 ? true : _ref$showLeftChevron,
      otherProps = _objectWithoutProperties(_ref, _excluded$4);

  var _useData = useData(),
      innerLinkStyles = _useData.globalStyles.innerLinkStyles;

  return /*#__PURE__*/React.createElement(InnerLinkBase, _extends({
    innerLinkStyles: innerLinkStyles
  }, otherProps), showLeftChevron && /*#__PURE__*/React.createElement("img", {
    alt: "to sign in page",
    src: img$2,
    style: s('text-pink-50')
  }), children);
}

var _excluded$3 = ["size", "thickness", "color", "backgroundColor"];

var _templateObject;
var spin = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Container$2 = styled.div(s('rounded-full bg-transparent border-solid self-center', {
  animation: "1.2s ".concat(spin, " cubic-bezier(0.66, 0, 0.2, 0.94) infinite")
}), function (_ref) {
  var size = _ref.size,
      thickness = _ref.thickness,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor;
  return {
    width: size,
    height: size,
    borderWidth: thickness,
    borderColor: backgroundColor,
    borderTopColor: color
  };
});

function Loader(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      _ref2$thickness = _ref2.thickness,
      thickness = _ref2$thickness === void 0 ? 6 : _ref2$thickness,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? '#b8c2cc' : _ref2$color,
      _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? '#f1f5f8' : _ref2$backgroundColor,
      props = _objectWithoutProperties(_ref2, _excluded$3);

  return /*#__PURE__*/React.createElement(Container$2, _extends({
    size: size,
    thickness: thickness,
    color: color,
    backgroundColor: backgroundColor
  }, props));
}

var _excluded$2 = ["value", "onChange"];
var Root = styled.div(s('flex flex-column'), prop('containerStyle'));
var InputContainer = styled.div(s('flex flex-1 bg-white relative rounded-lg'));
var Label$1 = styled.label(s('text-md mb-1 text-grey-800'), function (_ref) {
  var isVisible = _ref.isVisible;
  return !isVisible ? s('hidden') : {};
}, function (_ref2) {
  var labelPosition = _ref2.labelPosition;
  return labelPosition === 'inline' ? s('mr-2') : s('mb-1');
});
var Input$2 = styled.input(s('flex flex-1 pl-3 py-4 text-base rounded-lg border-1 border-solid border-grey-500 bg-white', {
  paddingRight: 40,
  boxSizing: 'border-box',
  '&::placeholder': s('text-grey-500'),
  '&:-webkit-autofill': {
    '-webkit-box-shadow': '0 0 0px 1000px white inset'
  }
}), function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError && s('border-1 border-error', {
    outline: 'none'
  });
}, prop('inputStyles'));
var IconContainer = styled.span(s('flex items-center justify-between absolute', {
  cursor: 'pointer',
  right: '12px',
  top: '50%',
  transform: 'translateY(-50%)'
}));
var ErrorMessage = styled.div(s('mt-2 text-error text-sm'));
var Memoized = /*#__PURE__*/memo(TextField);

function TextField(_ref4) {
  var name = _ref4.name,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      label = _ref4.label,
      _ref4$labelPosition = _ref4.labelPosition,
      labelPosition = _ref4$labelPosition === void 0 ? 'above' : _ref4$labelPosition,
      className = _ref4.className,
      placeholder = _ref4.placeholder,
      SuffixIcon = _ref4.SuffixIcon,
      containerStyle = _ref4.containerStyle,
      inputProps = _ref4.inputProps;

  var _useData = useData(),
      inputStyles = _useData.globalStyles.inputStyles;

  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    type: type
  }, function (_ref5) {
    var field = _ref5.field,
        meta = _ref5.meta;

    var value = field.value,
        onFieldChange = field.onChange,
        fieldProps = _objectWithoutProperties(field, _excluded$2);

    var touched = meta.touched,
        error = meta.error;
    var hasError = touched && isNotNilOrEmpty(error);
    return /*#__PURE__*/React.createElement(Root, {
      className: className,
      containerStyle: containerStyle
    }, /*#__PURE__*/React.createElement(Label$1, {
      isVisible: isNotNil(label),
      htmlFor: name,
      labelPosition: labelPosition
    }, label), /*#__PURE__*/React.createElement(InputContainer, {
      labelPosition: labelPosition
    }, /*#__PURE__*/React.createElement(Input$2, _extends({
      type: type,
      value: value,
      onChange: onFieldChange,
      id: name,
      placeholder: placeholder,
      inputStyles: inputStyles,
      hasError: hasError
    }, fieldProps, inputProps)), SuffixIcon && /*#__PURE__*/React.createElement(IconContainer, null, SuffixIcon)), hasError && /*#__PURE__*/React.createElement(ErrorMessage, null, error));
  });
}

var Header$6 = styled.div(s('text-center flex-shrink-0 mb-10'));
var ButtonContainer$5 = styled.div(s('flex flex-column mt-8'));
var Row$3 = styled.div(s('flex flex-row text-sm text-grey-dark'));

function ConfirmSignUp(_ref) {
  var slot = _ref.slot,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo,
      handleAuthStateChange = _ref.handleAuthStateChange;
  var signUpEmail = user.username;

  function handleConfirmSignUp(_x) {
    return _handleConfirmSignUp.apply(this, arguments);
  }

  function _handleConfirmSignUp() {
    _handleConfirmSignUp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var confirmationCode;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              confirmationCode = _ref2.confirmationCode;
              _context.prev = 1;
              _context.next = 4;
              return Auth.confirmSignUp(signUpEmail, confirmationCode);

            case 4:
              dispatchNewUserEvent('confirmSignUp', {
                email: signUpEmail
              });
              goToSignIn();
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              handleAuthError(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _handleConfirmSignUp.apply(this, arguments);
  }

  function goToSignIn() {
    handleAuthStateChange(AuthState.SignIn);
  }

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$6, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Confirm sign up"), /*#__PURE__*/React.createElement(Formik, {
    enableReinitialize: true,
    initialValues: {
      email: signUpEmail !== null && signUpEmail !== void 0 ? signUpEmail : '',
      confirmationCode: ''
    },
    onSubmit: handleConfirmSignUp
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Email",
      readOnly: true,
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(Memoized, {
      label: "Confirmation code",
      name: "confirmationCode",
      placeholder: "Confirmation code"
    }), /*#__PURE__*/React.createElement(Row$3, {
      style: s('mt-1')
    }, /*#__PURE__*/React.createElement(HelperText, null, "Didn't get your code?"), /*#__PURE__*/React.createElement(InnerLink, {
      style: s('ml-1'),
      showLeftChevron: false,
      onClick: function onClick() {
        return Auth.resendSignUp(signUpEmail);
      }
    }, "Resend Code")), /*#__PURE__*/React.createElement(ButtonContainer$5, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Submit')));
  }), /*#__PURE__*/React.createElement(Row$3, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(InnerLink, {
    onClick: goToSignIn
  }, "Back to Sign in")));
}

var img$1 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z' stroke='%23798582' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2.45801 12C3.73201 7.943 7.52301 5 12 5C16.478 5 20.268 7.943 21.542 12C20.268 16.057 16.478 19 12 19C7.52301 19 3.73201 16.057 2.45801 12Z' stroke='%23798582' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='%23798582' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21'/%3e%3c/svg%3e";

var _excluded$1 = ["id", "name", "disabled", "inputProps", "containerStyle", "testId"];
var string$1 = PropTypes.string,
    bool = PropTypes.bool,
    object$1 = PropTypes.object;

function PasswordField(_ref) {
  var id = _ref.id,
      name = _ref.name,
      disabled = _ref.disabled;
      _ref.inputProps;
      var containerStyle = _ref.containerStyle,
      testId = _ref.testId,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var togglePasswordVisibility = useCallback(function () {
    setShowPassword(!showPassword);
  }, [showPassword]);
  var Icon = showPassword ? img : img$1;
  var type = showPassword ? 'text' : 'password';
  return /*#__PURE__*/React.createElement(Memoized, _extends({
    id: id,
    name: name,
    label: "Password",
    SuffixIcon: /*#__PURE__*/React.createElement("img", {
      alt: "visibility toggler",
      src: Icon,
      onClick: togglePasswordVisibility
    }),
    inputProps: {
      type: type,
      disabled: disabled
    },
    containerStyle: containerStyle,
    testId: testId,
    fast: false
  }, otherProps));
}

PasswordField.propTypes = {
  id: string$1,
  name: string$1,
  label: string$1,
  disabled: bool,
  inputProps: object$1,
  containerStyle: object$1
};

var Header$5 = styled.div(s('text-center flex-shrink-0'));
var ButtonContainer$4 = styled.div(s('flex flex-column mt-8'));
var Row$2 = styled.div(s('flex items-center text-sm text-grey-dark'));

function ForgotPassword(_ref) {
  var slot = _ref.slot,
      handleAuthStateChange = _ref.handleAuthStateChange,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      shouldRequestCode = _useState2[0],
      setShouldRequestCode = _useState2[1];

  function handleRequestCode(_x) {
    return _handleRequestCode.apply(this, arguments);
  }

  function _handleRequestCode() {
    _handleRequestCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var email;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email;
              _context.prev = 1;
              _context.next = 4;
              return Auth.forgotPassword(email);

            case 4:
              setShouldRequestCode(false);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              handleAuthError(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));
    return _handleRequestCode.apply(this, arguments);
  }

  function handleResetPassword(_x2) {
    return _handleResetPassword.apply(this, arguments);
  }

  function _handleResetPassword() {
    _handleResetPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var email, code, password;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              email = _ref3.email, code = _ref3.code, password = _ref3.password;
              _context2.prev = 1;
              _context2.next = 4;
              return Auth.forgotPasswordSubmit(email, code, password);

            case 4:
              goToSignIn();
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              handleAuthError(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return _handleResetPassword.apply(this, arguments);
  }

  function goToSignIn() {
    handleAuthStateChange(AuthState.SignIn);
    setShouldRequestCode(true);
  }

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$5, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Reset Your Password"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      email: '',
      code: '',
      password: ''
    },
    onSubmit: shouldRequestCode ? handleRequestCode : handleResetPassword
  }, function (_ref4) {
    var isSubmitting = _ref4.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, shouldRequestCode ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Email"
    }), /*#__PURE__*/React.createElement(ButtonContainer$4, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Send Code')), ' ') : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "Verification code",
      name: "code",
      placeholder: "Verification code",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(PasswordField, {
      label: "Password",
      type: "password",
      name: "password",
      placeholder: "Password"
    }), /*#__PURE__*/React.createElement(ButtonContainer$4, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Submit'))));
  }), /*#__PURE__*/React.createElement(Row$2, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(InnerLink, {
    onClick: goToSignIn
  }, "Back to Sign in")));
}

var object = Validator.object,
    string = Validator.string;
var Header$4 = styled.div(s('text-center flex-shrink-0'));
var ButtonContainer$3 = styled.div(s('flex flex-column mt-8'));
var Footer$1 = styled.div(s('flex items-center text-sm text-grey-dark'));
var validationSchema = object({
  password: string().required('New password is required'),
  passwordConfirmation: string().required('Password confirmation is required').when(['password'], {
    is: function is(password) {
      return isNotNilOrEmpty(password);
    },
    then: string().test('is-password-confirmation-matches-new-password', 'Password confirmation is invalid', function (passwordConfirmation, context) {
      return equals(passwordConfirmation, context.parent.password);
    })
  })
});

function RequireNewPassword(_ref) {
  var slot = _ref.slot,
      cognitoUser = _ref.user,
      handleAuthStateChange = _ref.handleAuthStateChange,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo;

  function handleResetPassword(_x) {
    return _handleResetPassword.apply(this, arguments);
  }

  function _handleResetPassword() {
    _handleResetPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var password, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              password = _ref2.password;
              _context.prev = 1;
              _context.next = 4;
              return Auth.completeNewPassword(cognitoUser, password);

            case 4:
              user = _context.sent;
              _context.t0 = user.challengeName;
              _context.next = _context.t0 === ChallengeName.SMSMFA ? 8 : _context.t0 === ChallengeName.MFASetup ? 10 : 12;
              break;

            case 8:
              handleAuthStateChange(AuthState.ConfirmSignIn, user);
              return _context.abrupt("break", 14);

            case 10:
              handleAuthStateChange(AuthState.TOTPSetup, user);
              return _context.abrupt("break", 14);

            case 12:
              _context.next = 14;
              return checkContact(user, handleAuthStateChange);

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t1 = _context["catch"](1);
              handleAuthError(_context.t1);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));
    return _handleResetPassword.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$4, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Enter New Password"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      password: '',
      passwordConfirmation: ''
    },
    onSubmit: handleResetPassword,
    validationSchema: validationSchema
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting,
        errors = _ref3.errors;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "New password",
      type: "password",
      name: "password",
      placeholder: "New password",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(Memoized, {
      label: "Re-type New Password",
      type: "password",
      name: "passwordConfirmation",
      placeholder: "New password"
    }), /*#__PURE__*/React.createElement(ButtonContainer$3, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isNotNilOrEmpty(errors) || isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Complete')));
  }), /*#__PURE__*/React.createElement(Footer$1, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(InnerLink, {
    onClick: function onClick() {
      return handleAuthStateChange(AuthState.SignIn);
    }
  }, "Back to Sign in")));
}

var Header$3 = styled.div(s('text-center flex-shrink-0'));
var ButtonContainer$2 = styled.div(s('flex flex-column mt-8'));
var Row$1 = styled.div(s('flex flex-row text-sm text-grey-dark'));

function SignIn(_ref) {
  var slot = _ref.slot,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo,
      handleAuthStateChange = _ref.handleAuthStateChange;

  var _useData = useData(),
      allowSelfSignUp = _useData.allowSelfSignUp;
      _useData.globalStyles.helperTextStyles;

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$3, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Welcome back!"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: handleSignIn
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Email",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(PasswordField, {
      label: "Password",
      type: "password",
      name: "password",
      placeholder: "Password"
    }), /*#__PURE__*/React.createElement(Row$1, {
      style: s('mt-1')
    }, /*#__PURE__*/React.createElement(HelperText, null, "Forgot your password?"), /*#__PURE__*/React.createElement(InnerLink, {
      style: s('ml-1'),
      showLeftChevron: false,
      onClick: function onClick() {
        return handleAuthStateChange(AuthState.ForgotPassword);
      }
    }, "Reset password")), /*#__PURE__*/React.createElement(ButtonContainer$2, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Log In')));
  }), allowSelfSignUp && /*#__PURE__*/React.createElement(Row$1, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(HelperText, null, "Don't have an account?"), /*#__PURE__*/React.createElement(InnerLink, {
    style: s('ml-1'),
    onClick: function onClick() {
      return handleAuthStateChange(AuthState.SignUp);
    }
  }, "Sign up")));
}

var Header$2 = styled.div(s('text-center flex-shrink-0'));
var ButtonContainer$1 = styled.div(s('flex flex-column mt-8'));
var Footer = styled.div(s('text-sm text-grey-dark'));

var getFullName = function getFullName() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return compose(trim, join(' '))(_toConsumableArray(names));
};

function SignUp(_ref) {
  var slot = _ref.slot,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo,
      handleAuthStateChange = _ref.handleAuthStateChange;

  function handleSignUp(_x) {
    return _handleSignUp.apply(this, arguments);
  }

  function _handleSignUp() {
    _handleSignUp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var email, password, firstName, lastName, _yield$Auth$signUp, userConfirmed, userSub;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email, password = _ref2.password, firstName = _ref2.firstName, lastName = _ref2.lastName;
              _context.prev = 1;
              _context.next = 4;
              return Auth.signUp({
                username: email,
                password: password,
                attributes: {
                  email: email,
                  name: getFullName([firstName, lastName])
                }
              });

            case 4:
              _yield$Auth$signUp = _context.sent;
              userConfirmed = _yield$Auth$signUp.userConfirmed;
              userSub = _yield$Auth$signUp.userSub;
              dispatchNewUserEvent('signUp', {
                id: userSub,
                email: email,
                firstName: firstName,
                lastName: lastName,
                confirmed: userConfirmed
              });
              _context.next = 10;
              return handleSignIn({
                email: email,
                password: password
              });

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              handleAuthError(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));
    return _handleSignUp.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$2, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Join us now!"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: ''
    },
    onSubmit: handleSignUp
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "First Name",
      name: "firstName",
      placeholder: "Enter your first name",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(Memoized, {
      label: "Last Name",
      name: "lastName",
      placeholder: "Enter your last name",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(Memoized, {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Email",
      containerStyle: s('mb-5')
    }), /*#__PURE__*/React.createElement(PasswordField, {
      label: "Password",
      type: "password",
      name: "password",
      placeholder: "Password"
    }), /*#__PURE__*/React.createElement(ButtonContainer$1, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Continue')));
  }), /*#__PURE__*/React.createElement(Footer, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(HelperText, null, "Have an account? "), /*#__PURE__*/React.createElement(InnerLink, {
    onClick: function onClick() {
      return handleAuthStateChange(AuthState.SignIn);
    }
  }, "Sign in")));
}

var _excluded = ["id", "name", "label", "value", "containerProps", "readOnly"];
var Container$1 = styled.div(s('flex-1 flex flex-row text-black border-solid border-0 border-b-2 border-transparent rounded-lg px-3 py-2 items-center'), function (_ref) {
  var isChecked = _ref.isChecked;
  return isChecked ? s('bg-gray-200 border-gray-500') : s('bg-transparent ');
}, function (_ref2) {
  var readOnly = _ref2.readOnly;
  return {
    cursor: readOnly ? 'default' : 'pointer'
  };
});
var Label = styled.label(s('m-0 ml-2 text-sm font-light'), function (_ref3) {
  var readOnly = _ref3.readOnly;
  return readOnly ? s('text-gray-700', {
    cursor: 'default'
  }) : {
    cursor: 'pointer'
  };
});
var Input$1 = styled.input(function (_ref4) {
  var disabled = _ref4.disabled;
  return {
    cursor: disabled ? 'default' : 'pointer'
  };
});

function RadioButtonField(_ref5) {
  var id = _ref5.id,
      name = _ref5.name,
      label = _ref5.label,
      value = _ref5.value;
      _ref5.containerProps;
      var readOnly = _ref5.readOnly,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/React.createElement(Field, {
    name: name
  }, function (_ref6) {
    var field = _ref6.field;
    var isChecked = value === field.value;

    var onChange = function onChange() {
      if (readOnly) {
        return;
      }

      field.onChange(field.name)(value);
    };

    return /*#__PURE__*/React.createElement(Container$1, {
      isChecked: isChecked,
      readOnly: readOnly,
      onClick: onChange
    }, /*#__PURE__*/React.createElement(Input$1, _extends({}, field, {
      type: "radio",
      name: field.name,
      checked: value === field.value,
      onChange: onChange,
      disabled: readOnly
    }, props)), /*#__PURE__*/React.createElement(Label, {
      readOnly: readOnly,
      htmlFor: id
    }, label));
  });
}

var Header$1 = styled.div(s('text-center flex-shrink-0 mb-10'));
var ButtonContainer = styled.div(s('flex flex-column mt-8'));
var Row = styled.div(s('flex flex-row text-sm text-grey-dark'));

function VerifyContact(_ref) {
  var slot = _ref.slot,
      user = _ref.user,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } : _ref$Logo,
      handleAuthStateChange = _ref.handleAuthStateChange;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      shouldVerify = _useState2[0],
      setShouldVerify = _useState2[1];

  var unverifiedContacts = camelizeKeys(prop('unverified', user));

  function handleVerify(_x) {
    return _handleVerify.apply(this, arguments);
  }

  function _handleVerify() {
    _handleVerify = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var selectedAttribute;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedAttribute = _ref2.selectedAttribute;
              _context.prev = 1;
              _context.next = 4;
              return Auth.verifyCurrentUserAttribute(selectedAttribute);

            case 4:
              setShouldVerify(false);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              handleAuthError(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));
    return _handleVerify.apply(this, arguments);
  }

  function handleSubmit(_x2) {
    return _handleSubmit.apply(this, arguments);
  }

  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var selectedAttribute, code;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectedAttribute = _ref3.selectedAttribute, code = _ref3.code;
              _context2.prev = 1;
              _context2.next = 4;
              return Auth.verifyCurrentUserAttributeSubmit(selectedAttribute, code);

            case 4:
              handleAuthStateChange(AuthState.SignedIn, user);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              handleAuthError(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(InnerContainer, {
    slot: slot
  }, /*#__PURE__*/React.createElement(Header$1, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Verify your contact information"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      selectedAttribute: '',
      code: ''
    },
    onSubmit: shouldVerify ? handleVerify : handleSubmit
  }, function (_ref4) {
    var isSubmitting = _ref4.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, shouldVerify ? /*#__PURE__*/React.createElement(React.Fragment, null, prop('email', unverifiedContacts) && /*#__PURE__*/React.createElement(RadioButtonField, {
      label: "Email",
      name: "selectedAttribute",
      value: "email"
    }), prop('phoneNumber', unverifiedContacts) && /*#__PURE__*/React.createElement(RadioButtonField, {
      label: "Phone number",
      name: "selectedAttribute",
      value: "phoneNumber"
    }), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Verify'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Memoized, {
      label: "Verification code",
      name: "code",
      placeholder: "Verification code"
    }), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting
    }, isSubmitting ? /*#__PURE__*/React.createElement(Loader, null) : 'Submit'))));
  }), /*#__PURE__*/React.createElement(Row, {
    style: s('mt-8')
  }, /*#__PURE__*/React.createElement(InnerLink, {
    onClick: function onClick() {
      return handleAuthStateChange(AuthState.SignedIn);
    }
  }, "Skip")));
}

function SoltaAuth(_ref) {
  var Logo = _ref.Logo,
      _ref$customStyles = _ref.customStyles,
      customStyles = _ref$customStyles === void 0 ? defaultGlobalStyles : _ref$customStyles,
      _ref$allowSelfSignUp = _ref.allowSelfSignUp,
      allowSelfSignUp = _ref$allowSelfSignUp === void 0 ? true : _ref$allowSelfSignUp;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      user = _useState2[0],
      setUser = _useState2[1]; // Make sure the overflow spaces to have background color


  useEffect(function () {
    var _document, _document$body, _document$body$style, _customStyles$contain;

    var originalBgColor = (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$style = _document$body.style) === null || _document$body$style === void 0 ? void 0 : _document$body$style.backgroundColor;
    var customBgColor = customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$contain = customStyles.containerStyles) === null || _customStyles$contain === void 0 ? void 0 : _customStyles$contain.backgroundColor;
    if (isNotNilOrEmpty(customBgColor)) document.body.style.backgroundColor = customBgColor;
    return function () {
      if (isNotNilOrEmpty(originalBgColor)) document.body.style.backgroundColor = originalBgColor;
    };
  }, []);
  useEffect(function () {
    return onAuthUIStateChange(function (_, authData) {
      setUser(authData);
    });
  }, []);
  return /*#__PURE__*/React.createElement(DataProvider, {
    customStyles: customStyles,
    allowSelfSignUp: allowSelfSignUp
  }, /*#__PURE__*/React.createElement(AmplifyAuthenticator, {
    style: {
      width: '100vw',
      height: '100vh'
    }
  }, /*#__PURE__*/React.createElement(SignIn, {
    slot: "sign-in",
    Logo: Logo,
    handleAuthStateChange: handleAuthStateChange
  }), /*#__PURE__*/React.createElement(Loader, {
    slot: "loading"
  }), /*#__PURE__*/React.createElement(SignUp, {
    slot: "sign-up",
    Logo: Logo,
    handleAuthStateChange: handleAuthStateChange
  }), /*#__PURE__*/React.createElement(ForgotPassword, {
    slot: "forgot-password",
    Logo: Logo,
    handleAuthStateChange: handleAuthStateChange
  }), /*#__PURE__*/React.createElement(RequireNewPassword, {
    slot: "require-new-password",
    Logo: Logo,
    user: user,
    handleAuthStateChange: handleAuthStateChange
  }), /*#__PURE__*/React.createElement(VerifyContact, {
    slot: "verify-contact",
    Logo: Logo,
    user: user,
    handleAuthStateChange: handleAuthStateChange
  }), /*#__PURE__*/React.createElement(ConfirmSignUp, {
    slot: "confirm-sign-up",
    Logo: Logo,
    user: user,
    handleAuthStateChange: handleAuthStateChange
  })));
}

var Container = styled.div(s('pb-4'));
var QrContainer = styled.div(s('flex justify-center text-center p-4'));
var Instruction$1 = styled.p(s('text-base'));
var QrSection = function QrSection(_ref) {
  var totpCode = _ref.totpCode,
      totpCodeUri = _ref.totpCodeUri,
      onContinue = _ref.onContinue;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Instruction$1, null, "Please scan this QR Code on a Authenticator App"), isNotNilOrEmpty(totpCode) ? /*#__PURE__*/React.createElement(QrContainer, null, /*#__PURE__*/React.createElement(QRCode, {
    value: totpCodeUri
  }), " ") : /*#__PURE__*/React.createElement("p", null, "loading"), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: onContinue
  }, "Continue"));
};

styled.div(s('flex justify-center text-center p-4'));
var Instruction = styled.p(s('text-base'));
var Input = styled.input(s('w-full flex flex-1 pl-3 py-4 text-base rounded-lg border-1 border-solid border-grey-500 bg-white mb-2', {
  paddingRight: 40,
  boxSizing: 'border-box',
  '&::placeholder': s('text-grey-500'),
  '&:-webkit-autofill': {
    '-webkit-box-shadow': '0 0 0px 1000px white inset'
  }
}));
var CompleteButton = styled(Button)(s('mb-2'));
var ChallengeCodeSection = function ChallengeCodeSection(_ref) {
  var onComplete = _ref.onComplete;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      challengeCode = _useState2[0],
      setChallengeCode = _useState2[1];

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Instruction, null, "Please enter code from your Authenticator App"), /*#__PURE__*/React.createElement(Input, {
    label: "Code",
    type: "text",
    name: "challenge-code",
    placeholder: "e.g 123 456",
    onChange: function onChange(e) {
      return setChallengeCode(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(CompleteButton, {
    type: "button",
    onClick: function onClick() {
      return onComplete(challengeCode);
    }
  }, "Complete"));
};

var Header = styled.div(s('text-center flex-shrink-0'));

var buildTotpUri = function buildTotpUri(_ref, code) {
  var username = _ref.username,
      email = _ref.attributes.email;
  return "otpauth://totp/AWSCognito:".concat(username, "?secret=").concat(code, "&issuer=Neo Bank (").concat(email, ")");
};

function TOTPSetup(_ref2) {
  var Logo = _ref2.Logo,
      customStyles = _ref2.customStyles,
      onSuccess = _ref2.onSuccess;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      currentUser = _useState2[0],
      setCurrentUser = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isQrScanned = _useState4[0],
      setIsQrScanned = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      totpCode = _useState6[0],
      setTotpCode = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      totpCodeUri = _useState8[0],
      setTotpCodeUri = _useState8[1];

  var verifyTotp = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user, challengeCode, callback) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AuthSdk.verifyTOTPSetup(user, challengeCode);

            case 2:
              result = _context.sent;

              if (isNotNilOrEmpty(result) && result.status === 'success') {
                callback(user);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }());
  useEffect(function () {
    var getUser = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userResponse, code, totpUri;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AuthSdk.getFullUserDetails();

              case 2:
                userResponse = _context2.sent;
                setCurrentUser(userResponse); // TODO: Handle Invalid User Response

                _context2.next = 6;
                return AuthSdk.setupTOTP(userResponse);

              case 6:
                code = _context2.sent;
                // TODO: Handle Invalid Code
                setTotpCode(code);
                totpUri = buildTotpUri(userResponse, code);
                setTotpCodeUri(totpUri);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getUser() {
        return _ref4.apply(this, arguments);
      };
    }();

    getUser();
  }, []);
  return /*#__PURE__*/React.createElement(DataProvider, {
    customStyles: customStyles,
    allowSelfSignUp: false
  }, /*#__PURE__*/React.createElement(InnerContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(Heading, null, "Multi-Factor Authentication"), isQrScanned ? /*#__PURE__*/React.createElement(ChallengeCodeSection, {
    onComplete: function onComplete(code) {
      return verifyTotp(currentUser, code, onSuccess);
    }
  }) : /*#__PURE__*/React.createElement(QrSection, {
    totpCode: totpCode,
    totpCodeUri: totpCodeUri,
    onContinue: function onContinue() {
      return setIsQrScanned(true);
    }
  }), /*#__PURE__*/React.createElement(HelperText, null, "2-Step Verification provides stronger security for your Neo Account by requiring a second verification step when you sign in. In addition to your password, you will need a code generated by an Authenticator app.")));
}

export { SoltaAuth, TOTPSetup };
